<template>
  <div class="element-props">
    <div
      class="modal element-props-modal fancy-scroll"
      :class="{
        'shift-right': isCreateCustomDB,
        'overflow-hidden': isOverFlowHidden,
      }"
      @scroll.passive="showScrollbar"
      ref="elementPropModalRef"
    >
      <div class="modal-close" @click="close"></div>
      <div class="content">
        <div class="tab">
          <h1>Element Bearbeiten</h1>
          <form id="add-element" @submit.prevent="handleSubmission">
            <div class="link-db-container" v-if="isShowTypeDropDown">
              <label for="type">Type</label>
              <GeneralDropdown
                className="database-dropdown"
                class="mb-3"
                :disabled="!isUserHasAccess"
              >
                <template v-slot:selectFilter>
                  {{
                    selectedType
                      ? typeGermanTranslation[selectedType]
                      : 'select'
                  }}
                </template>
                <template v-slot:optionData>
                  <b-dropdown-item
                    v-for="group in typeDropdownItems[groupArrayIndex]"
                    :key="group"
                    @click="changeElementType(group)"
                    class="group-items"
                    :class="{ selected: group === selectedType }"
                  >
                    {{ typeGermanTranslation[group] }}
                  </b-dropdown-item>
                </template>
              </GeneralDropdown>
            </div>
            <label for="name">Name</label>
            <input
              name="name"
              type="text"
              :disabled="
                ['togglelist', 'wrapper'].includes(element.type) ||
                !isUserHasAccess ||
                isSheetDatabaseType
              "
              v-model="element.name"
              required
              onkeyup="this.value = this.value.toLowerCase()"
              @blur="transformName"
              pattern="^[a-z0-9äöü]+$"
              :class="{
                'already-exists': nameAlreadyExists && element.name != '',
                error: isPropsError || (shakeName && nameAlreadyExists),
              }"
              @input="handleInputValidation"
              @invalid="handleInputValidation"
            />
            <label for="label">Bezeichnung</label>
            <input
              name="label"
              type="text"
              v-model="element.label"
              @blur="updateDatabaseLinkedViewCaption()"
              :required="isCreateCustomDB"
              @input="handleInputValidation"
              @invalid="handleInputValidation"
            />

            <div v-if="element.type === 'linktodb'" class="link-db-container">
              <SelectDatabase
                :selectedDatabaseCaption="element.selectedDatabaseCaption"
                :selectedDatabaseName="element.selectedDatabaseID"
                :userTables="getDatabaseList"
                componentName="link-to-db"
                @onDatabaseSelect="selectDatabaseFromDropdown"
                placeholder="select"
                label="Datenbank"
                :isUserHasAccess="isUserHasAccess"
              />
            </div>

            <div v-if="element.type === 'linktodb'" class="link-db-container">
              <label for="label">Item Id</label>
              <GeneralDropdown
                className="database-dropdown"
                class="mb-3"
                :disabled="!isUserHasAccess"
              >
                <template v-slot:selectFilter>
                  <span class="database-dropdown-value-container">
                    {{ getLinktoDbValue(element.value) }}
                  </span>
                </template>
                <template v-slot:optionData>
                  <b-dropdown-item
                    style="height: 40px"
                    v-if="isDbItemListLoading"
                  >
                    <div class="loading-overlay">
                      <div class="progress-icon"></div>
                    </div>
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-for="(item, index) in getDatabaseItemsList"
                    :key="`${item.id}-${index}`"
                    @click="onDatabaseItemChange(item)"
                    v-show="!isDbItemListLoading"
                  >
                    <div>
                      {{ getLinktoDbValue(item.id) }}
                    </div>
                  </b-dropdown-item>
                </template>
              </GeneralDropdown>
            </div>

            <div v-show="elementNeedsOptions">
              <label>Optionen:</label>
              <div
                v-for="(option, index) in element.options"
                :key="index"
                class="options"
                :class="{
                  large: isCardItem || isSelectableElements(element.type),
                  'option-card': isCardItem,
                }"
              >
                <table>
                  <tr>
                    <td
                      :class="{
                        'selectable-elements-option-wrapper':
                          isRadioOrCheckboxElement(element.type),
                      }"
                    >
                      <input
                        v-if="['radio', 'status'].includes(element.type)"
                        :type="optionInputType"
                        :id="element.name + option.label"
                        :name="element.name"
                        :value="option.value"
                        @change="changeChecked(option, element.type)"
                        :checked="
                          isRadioButtonNotPrefilled ? false : option.checked
                        "
                        :disabled="!isUserHasAccess"
                      />
                      <input
                        v-if="element.type === 'checkbox'"
                        :type="element.type"
                        :id="element.name + option.label"
                        :name="element.name"
                        :value="option.value"
                        :checked="option.checked"
                        @change="changeChecked(option, element.type)"
                        :disabled="
                          element.attributes.disabled || !isUserHasAccess
                        "
                      />
                      <span
                        style="padding-top: 8px"
                        v-if="isSelectableElements(element.type)"
                      >
                        label
                      </span>
                    </td>
                    <td>
                      <input
                        :class="{
                          invalid:
                            lastUpdatedInvalidOptionIndexes.includes(index),
                        }"
                        type="text"
                        placeholder="Option"
                        v-model="option.label"
                        :disabled="!isUserHasAccess"
                        @keyup="changeOption($event, index)"
                      />
                    </td>
                  </tr>
                  <tr v-if="isSelectableElements(element.type)">
                    <td>
                      <span v-if="isSelectableElements(element.type)">
                        value
                      </span>
                    </td>
                    <td>
                      <input
                        v-if="isSelectableElements(element.type)"
                        :class="{
                          invalid:
                            element.type === 'status'
                              ? lastUpdatedInvalidOptionValueIndexes.includes(
                                  index
                                )
                              : handleOptionValue(option, index),
                        }"
                        type="text"
                        placeholder="Option"
                        v-model="option.value"
                        :disabled="!isUserHasAccess"
                        @input="validateOptions()"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td class="img-preview">
                      <img v-if="isCardItem && option.img" :src="option.img" />
                    </td>
                    <td>
                      <div v-if="isCardItem" class="icon-picker-url-selector">
                        <div
                          class="btn"
                          @click.stop="toggleIconPickerURL(index)"
                          :class="{ 'disable-element': !isUserHasAccess }"
                        >
                          <span> Bild hinzufügen </span>
                        </div>

                        <IconPicker
                          v-if="index == iconPickerURLId"
                          :displayIconPickerSections="[
                            'icon',
                            'illustration',
                            'custom',
                          ]"
                          :element="option"
                          @updateUrl="
                            (icon) => {
                              updateUrl(icon, index);
                            }
                          "
                          @updateLinkType="
                            (tab) => {
                              updateLinkType(tab, index);
                            }
                          "
                          v-click-outside="toggleIconPickerURL"
                        />
                      </div>
                    </td>
                  </tr>
                  <tr v-if="isChoiceWithAppearanceCard(element)">
                    <td></td>
                    <td>
                      <textarea
                        v-if="isShowDescription"
                        class="description-input"
                        :id="`description-${index}-0`"
                        placeholder="Description"
                        v-model="option.description"
                        :disabled="!isUserHasAccess"
                      />
                    </td>
                  </tr>
                </table>

                <i
                  class="far fa-trash-alt"
                  @click="removeElement(option, index)"
                ></i>
              </div>
              <div>
                <div class="element-image" v-if="element.type === 'video'">
                  <input
                    type="text"
                    placeholder="Video URL"
                    v-model="element.url"
                    :required="isElementValueRequired(element)"
                    :disabled="!isUserHasAccess"
                  />
                </div>
                <div
                  class="element-image icon-picker-url-selector"
                  v-if="element.type === 'image'"
                >
                  <div
                    class="btn"
                    @click.stop="toggleIconPickerURL(element.id)"
                    :class="{ 'disable-element': !isUserHasAccess }"
                  >
                    <span> Bild hinzufügen </span>
                  </div>

                  <IconPicker
                    v-if="element.id == iconPickerURLId"
                    v-click-outside="toggleIconPickerURL"
                    :displayIconPickerSections="[
                      'icon',
                      'illustration',
                      'custom',
                    ]"
                    :element="element"
                    @updateUrl="updateUrl"
                    @updateLinkType="updateLinkType"
                  />
                </div>
              </div>
              <input
                v-if="addAnotherOption"
                :class="{ invalid: invalidOptionName }"
                class="new-item"
                ref="newOption"
                type="text"
                placeholder="Neue Option Hinzufügen ..."
                @change="addOption(element)"
                :disabled="!isUserHasAccess"
              />
              <p v-if="invalidOptionName" class="invalid">
                Option existiert schon
              </p>
            </div>

            <!-- List items -->
            <div v-if="element.type === 'objectlist'" class="list-wrapper">
              <label>Schema</label>
              <div class="schema-item">
                <span v-if="element.schema.length === 0"
                  >Konfigurieren Sie Ihren Listeneintrag.</span
                >
                <FormBuilder
                  ref="formBuilder"
                  class="el-props-form-builder"
                  :elements="element.schema"
                  :structure="baseStructure"
                  :isFullWidth="false"
                  :isEditable="true"
                  :isContentEditable="true"
                  :elsToShow="[
                    'text',
                    'number',
                    'checkbox',
                    'radio',
                    'date',
                    'datetime-local',
                    'email',
                    'formated number',
                  ]"
                  @saveElements="saveListSchema"
                  :isCalledInElementsProps="true"
                  :isCreateCustomDB="isCreateCustomDB"
                  :selectedDatabase="selectedDatabase"
                  @objectListModalWatch="objectListModalWatch"
                />
              </div>
              <div class="item-list" v-if="element.schema.length != 0">
                <label>Items</label>
                <Cards
                  :schema="element.schema"
                  :cards="element.value"
                  :itemWidth="'100%'"
                />
              </div>
            </div>
            <!-- List items end -->

            <label v-show="getLabelCaption(element.type)">{{
              getLabelCaption(element.type)
            }}</label>
            <!-- File Picker  Start -->
            <div class="edit-item">
              <FilePicker
                v-if="element.type === 'filenew'"
                ref="filePickerRef"
                @onFileSelected="onFileSelected"
                @onFileDelete="onFileDelete"
                :value="element.value"
              />
            </div>
            <!-- File Picker End -->

            <!-- Sheet  Start -->
            <div v-if="element.type === 'sheet'">
              <div class="btn" @click="$refs.hiddenSheetInput.click()">
                <span>Create Schema</span>
              </div>
              <input
                @change="onSheetFileSelect"
                ref="hiddenSheetInput"
                type="file"
                accept=".xls, .xlsx, .csv"
                hidden
              />
            </div>
            <!-- Sheet  End -->
            <input
              v-if="element.type === 'file'"
              :key="element.id"
              name="example"
              :type="element.type"
              @change="getFiles"
              ref="fileInput"
              :required="element.attributes.required"
              :disabled="!isUserHasAccess"
            />

            <input
              v-if="isInputRequired(element.type)"
              name="example"
              ref="textInputRef"
              :type="getInputType"
              v-model="element.value"
              :required="isElementValueRequired(element)"
              :disabled="!isUserHasAccess"
              :pattern="getPattern"
              :min="
                element.type === 'datetime-local' ? '1000-01-01T00:00' : null
              "
              :max="
                element.type === 'datetime-local' ? '9999-12-31T23:59' : null
              "
              @input="addValidationMessage"
              @invalid="addValidationMessage"
            />

            <textarea
              v-if="element.type === 'textarea' || element.type === 'html'"
              name="example"
              v-model="element.value"
              :required="isElementValueRequired(element)"
              :disabled="!isUserHasAccess"
              @input="handleInputValidation"
              @invalid="handleInputValidation"
              ref="textareaInputRef"
            />

            <!-- Input for number - v.model.number is required -->
            <div
              v-else-if="
                element.type === 'number' ||
                element.type === 'range' ||
                element.type === 'timestampms'
              "
              class="numeric-input-wrapper"
              :class="element.type === 'range' && 'range-wrapper'"
            >
              <div class="range-slider-values" v-if="element.type === 'range'">
                <div class="min-value">
                  {{ formatWithThousandSeparator(element.attributes.min) }}
                </div>
                <div class="max-value">
                  {{ formatWithThousandSeparator(element.attributes.max) }}
                </div>
              </div>
              <input
                name="example"
                :type="element.type === 'timestampms' ? 'number' : element.type"
                v-model.number="element.value"
                :step="element.attributes.step"
                :max="element.attributes.max"
                :min="element.attributes.min"
                :required="isElementValueRequired(element)"
                :disabled="!isUserHasAccess"
                :class="
                  element.type === 'range' && 'range-input custom-range-input'
                "
                @input="onNumberRangeInputValueChange($event, element)"
                :ref="
                  element.type === 'range'
                    ? `rangeInput${element.id}`
                    : 'numberInputRef'
                "
                @invalid="handleInputValidation"
              />
              <output
                v-if="element.type === 'range'"
                class="range-output-value"
                :ref="`rangeoutput${element.id}`"
                >{{ formatWithThousandSeparator(element.value) }}</output
              >
            </div>
            <NumberComponent
              v-else-if="element.type === 'formatted_number'"
              :editableComponent="true"
              :maxValue="Number(element.attributes.max) || Infinity"
              :minValue="Number(element.attributes.min) || -Infinity"
              :decimalValuesCount="Number(element.settings.toFixed)"
              :passedNumberValue="element.value || 0"
              :disabledInput="!isUserHasAccess"
              @onNumberInputChange="onNumberComponentInputChange"
              :requiredInput="isElementValueRequired(element)"
              @toggleValidationError="toggleErrorInForm"
              :formatNumber="getFormatNumber()"
              :key="element.id"
              ref="numberComponentRef"
            />

            <!-- :maximumDecimalValues="Number(element.attributes.step || 3)" -->

            <!-- database linked view started-->
            <div class="database-linked-view">
              <div v-if="element.type === 'databaselinkedview'">
                <SelectDatabase
                  :selectedDatabaseCaption="
                    element?.settings?.connectedDatabase
                      ?.selectedDatabaseCaption
                  "
                  :selectedDatabaseName="
                    element?.settings?.connectedDatabase?.selectedDatabaseID
                  "
                  :userTables="getDatabaseList"
                  componentName="database-linked-view"
                  @onDatabaseSelect="onSelectLinkedViewDatabase"
                  placeholder="select"
                  label="Datenbank"
                  :isUserHasAccess="isUserHasAccess"
                />
              </div>
              <div v-if="element.type === 'databaselinkedview'">
                <label for="label">Item</label>
                <GeneralDropdown
                  className="database-dropdown"
                  class="mb-3"
                  :disabled="!isUserHasAccess"
                >
                  <template v-slot:selectFilter>
                    <span class="database-dropdown-value-container">
                      {{
                        element?.databaseLink?.currentTableFieldCaption
                          ? element.databaseLink.currentTableFieldCaption
                          : 'select'
                      }}
                    </span>
                  </template>
                  <template v-slot:optionData>
                    <b-dropdown-item
                      style="height: 40px"
                      v-if="isDbItemListLoading"
                    >
                      <div class="loading-overlay">
                        <div class="progress-icon"></div>
                      </div>
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-for="(item, index) in getSelectedDatabaseFields"
                      :key="`db-item-${index}`"
                      @click="onSelectDatabseLinkedtoViewKey(item)"
                      v-show="!isDbItemListLoading"
                      :class="{
                        'is-dropdown-container-overflowed':
                          getSelectedDatabaseFields.length >= 6,
                      }"
                    >
                      {{ item.label }}
                    </b-dropdown-item>
                  </template>
                </GeneralDropdown>
                <div v-if="!databaseColumnLoading">
                  <label for="label">Columns</label>
                  <GeneralDropdown
                    className="database-columns-dropdown"
                    class="mb-3"
                    :disabled="!isUserHasAccess"
                  >
                    <template v-slot:selectFilter>
                      <span class="display-columns">{{
                        databaseLinkedViewSelectedColumn
                      }}</span>
                    </template>
                    <template v-slot:optionData>
                      <b-dropdown-item
                        v-for="(item, index) in databaseLinkedViewColumns"
                        :key="`${item.name}-${index}`"
                        @click="databaseLinkedViewColumnSelect(item.name)"
                        v-show="!databaseColumnLoading"
                        :class="{
                          'is-dropdown-container-overflowed':
                            databaseLinkedViewColumns.length >= 6,
                        }"
                      >
                        {{ item.label }}
                      </b-dropdown-item>
                    </template>
                  </GeneralDropdown>
                  <div
                    v-if="selectedDatabaseColumn.length"
                    class="selected-columns"
                  >
                    <draggable
                      v-model="selectedDatabaseColumn"
                      @end.stop
                      class="drag-wrapper fancy-scroll"
                      @scroll.passive.stop="showScrollbar"
                    >
                      <div
                        v-for="(item, index) in selectedDatabaseColumn"
                        :key="`${item.name}-${index}`"
                        class="selected-column"
                      >
                        <div class="drag-content">
                          <div data-v-261bea02="" class="drag-icon">
                            <i data-v-261bea02="" class="fas fa-bars"></i>
                          </div>
                          <span>{{ databaseLinkedViewColumnLabel(item) }}</span>
                        </div>
                        <b-icon
                          v-if="
                            item !== element?.databaseLink?.currentTableFieldKey
                          "
                          icon="x-lg"
                          font-scale="0.8"
                          class="close"
                          @click.stop="databaseLinkedViewRemoveColumn(item)"
                        ></b-icon>
                      </div>
                    </draggable>
                  </div>
                </div>
                <div class="column-loader" v-if="databaseColumnLoading">
                  <div class="loading-overlay">
                    <div class="progress-icon"></div>
                  </div>
                </div>
              </div>
            </div>

            <!-- database linked view ended-->

            <!-- This input allows the user to set default value for hidden input -->
            <input
              v-if="element.type === 'hidden'"
              name="example"
              v-model="element.value"
              :required="element.attributes.required"
              :disabled="!isUserHasAccess"
            />
            <br />
            <a
              style="font-size: 13px; font-weight: 600"
              v-if="!getElementSettings('layoutItem')"
              @click="isMoreSettingsVisible = !isMoreSettingsVisible"
              >Zusätzliche Einstellungen<i
                style="margin-left: 5px"
                class="fa fa-angle-double-down"
              ></i
            ></a>
            <br />
            <br />
            <div class="more-settings" v-show="isMoreSettingsVisible">
              <div v-if="element.type === 'formatted_number'">
                <label>Dezimalzahlen zählen</label>
                <span>{{ element.settings.toFixed }}</span>
                <input
                  type="range"
                  min="0"
                  max="6"
                  v-model.number="element.settings.toFixed"
                  :disabled="!isUserHasAccess"
                />
                <label>Dezimaltrennzeichen</label>
                <input
                  type="text"
                  v-model="element.settings.decSep"
                  v-b-tooltip.hover
                  title="Nur die Zeichen  .  ,  und  '  sind in diesem Eingabefeld erlaubt."
                  @input="validateInput($event, true)"
                  :disabled="!isUserHasAccess"
                />
                <label>Tausendertrennzeichen</label>
                <input
                  type="text"
                  v-model="element.settings.thSep"
                  v-b-tooltip.hover
                  title="Nur die Zeichen  .  ,  und  '  sind in diesem Eingabefeld erlaubt."
                  @input="validateInput($event, false)"
                  :disabled="!isUserHasAccess"
                />
              </div>
              <div v-if="element.type === 'checkbox'">
                <label>Minimum</label>
                <input
                  type="number"
                  v-model.number="element.settings.min"
                  min="0"
                  :max="element.options.length"
                  :class="{
                    'checkbox-error': isCheckboxMinError(element),
                  }"
                  @input="onMinValueChange(element)"
                  :disabled="!isUserHasAccess"
                />
                <label>Maximum</label>
                <input
                  :class="{
                    'checkbox-error': isCheckBoxMaxError(element),
                  }"
                  type="number"
                  v-model.number="element.settings.max"
                  min="0"
                  :max="element.options.length"
                  :disabled="!isUserHasAccess"
                />
              </div>
              <label
                v-if="isPlaceholderRequired(element.type)"
                for="placeholder"
                >Platzhalter:</label
              >
              <input
                v-if="isPlaceholderRequired(element.type)"
                name="placeholder"
                type="text"
                v-model="element.placeholder"
                :disabled="!isUserHasAccess"
              />

              <!-- Options for numbers / range -->
              <div v-if="isNumberRangeVisible(element.type)">
                <label for="label">Minimum</label>
                <input
                  name="label"
                  type="number"
                  v-model="element.attributes.min"
                  :disabled="!isUserHasAccess"
                  @input="onNumberRangeInputMinMaxChange($event, element)"
                  :max="getNumberRangeElementMinMax(element, 'max')"
                  :class="{
                    'input-error':
                      isElementTypeRange(element) &&
                      (isRangeMinMaxInputError() || !element.attributes.min),
                  }"
                />
                <label for="label">Maximum</label>
                <input
                  name="label"
                  type="number"
                  v-model="element.attributes.max"
                  :disabled="!isUserHasAccess"
                  @input="onNumberRangeInputMinMaxChange($event, element)"
                  :min="getNumberRangeElementMinMax(element, 'min')"
                  :class="{
                    'input-error':
                      isElementTypeRange(element) &&
                      (isRangeMinMaxInputError() || !element.attributes.max),
                  }"
                />
              </div>

              <!-- This input allows the user to set tabindex for non-layoutItem's -->
              <label v-if="!getElementSettings('layoutItem')" for="tabindex"
                >Tabindex:</label
              >
              <input
                v-if="!getElementSettings('layoutItem')"
                name="tabindex"
                type="number"
                placeholder="Dieser Wert ist optional"
                v-model="element.attributes.tabindex"
                :disabled="!isUserHasAccess"
              />
              <!-- This input allows the user to set pattern for only type text -->
              <label v-if="element.type === 'text'" for="pattern"
                >Pattern:</label
              >
              <input
                v-if="element.type === 'text'"
                name="pattern"
                type="text"
                placeholder="Eingabemuster hinzufügen"
                v-model="element.attributes.pattern"
                :disabled="!isUserHasAccess"
                @input="onTextPatternChange"
              />

              <label v-if="element.type === 'text'" for="pattern"
                >Error mesaage:</label
              >
              <input
                v-if="element.type === 'text'"
                name="error-message"
                type="text"
                placeholder="Fehlermeldung"
                v-model="element.attributes.errorMessage"
                :disabled="!isUserHasAccess"
              />

              <div
                class="switch-group"
                v-if="
                  isCreateCustomDB && ['text', 'email'].includes(element.type)
                "
              >
                <label class="caption">Verknüpfungslabel</label>
                <label name="required" class="switch class pull-right">
                  <input
                    ref="showcaseField"
                    type="checkbox"
                    :checked="element.settings.showcaseField"
                    @click="toggleShowcaseField"
                    :disabled="!isUserHasAccess"
                  />
                  <span
                    class="slider round"
                    :disabled="!isUserHasAccess"
                  ></span>
                </label>
              </div>

              <div
                class="switch-group"
                v-if="
                  element.type === 'date' || element.type === 'datetime-local'
                "
              >
                <label class="caption">Heute als Standardwert</label>
                <label name="required" class="switch class pull-right">
                  <input
                    type="checkbox"
                    :checked="element.attributes.todayAsDefaultValue"
                    @click="onclickTodayAsDefaultValue"
                    :disabled="!isUserHasAccess"
                  />
                  <span
                    class="slider round"
                    :disabled="!isUserHasAccess"
                  ></span>
                </label>
              </div>

              <!-- This input allows the user to set the number of decimals for number inputs -->
              <label v-if="isNumberRangeVisible(element.type)"
                >Dezimalstellen:</label
              >
              <p
                class="decimal-description"
                v-if="isNumberRangeVisible(element.type)"
              >
                Erhöhungsschritte oder gewünschte Anzahl an Dezimalen
                definieren. Für Standardeinstellungen Feld leer lassen.
              </p>
              <input
                v-if="isNumberRangeVisible(element.type)"
                name="example decimals"
                type="number"
                step="any"
                min="0"
                v-model="element.attributes.step"
                :disabled="!isUserHasAccess"
              />
              <!-- min="1" -->

              <label v-show="isExampleFieldLabel(element.type)">Text:</label>
              <textarea
                v-if="isExampleFieldTextarea(element.type)"
                name="example"
                v-model="element.value"
                required
                :disabled="!isUserHasAccess"
                @input="handleInputValidation"
                @invalid="handleInputValidation"
              />
            </div>

            <!-- Dropdown preview - this is just for type: select -->
            <div v-if="element.type === 'select'">
              <h3>Dropdown vorschau</h3>
              <p>Wert: {{ dropdownSelection }}</p>
              <GeneralDropdown
                className="database-dropdown"
                :disabled="!isUserHasAccess"
                v-if="element.type == 'select'"
              >
                <span>{{ element.label }}</span>
                <template v-slot:selectFilter>
                  <span>{{ isSelectedOptionLabel }}</span>
                </template>
                <template v-slot:optionData>
                  <b-dropdown-item
                    v-for="(option, index) in element.options"
                    :key="index"
                    :class="element.name"
                    @click="changeChecked(option, element.type)"
                  >
                    {{ option.label }}
                  </b-dropdown-item>
                </template>
              </GeneralDropdown>
            </div>

            <div v-if="elementNeedsSettings">
              <div class="switch-group" v-if="isElementNeedsRequiredToggle">
                <label class="caption">Feld Erforderlich</label>
                <label name="required" class="switch class pull-right">
                  <input
                    type="checkbox"
                    :checked="element.attributes.required"
                    @click="onclickIsRequired()"
                    :disabled="!isUserHasAccess"
                  />
                  <span
                    class="slider round"
                    :disabled="!isUserHasAccess"
                  ></span>
                </label>
              </div>
              <div
                v-if="
                  element.type != 'file' &&
                  element.type != 'filenew' &&
                  isCreateCustomDB
                "
                class="switch-group"
              >
                <label class="caption">Feld hevorheben </label>
                <label name="highlight" class="switch class pull-right">
                  <input
                    type="checkbox"
                    :checked="getElementSettings('highlight')"
                    @click="toggleHighlight"
                    :disabled="!isUserHasAccess"
                  />
                  <span
                    class="slider round"
                    :disabled="!isUserHasAccess"
                  ></span>
                </label>
              </div>
              <div v-if="elementNeedsDefaultValue" class="switch-group">
                <label class="caption">
                  Beispielwert als Standartwert verwenden
                </label>
                <label name="default" class="switch class pull-right">
                  <input
                    type="checkbox"
                    :checked="
                      getElementSettings('default') ||
                      ['radio', 'status'].includes(element.type)
                    "
                    @click="toggleDefault"
                    :disabled="!isUserHasAccess"
                  />
                  <span
                    class="slider round"
                    :disabled="!isUserHasAccess"
                  ></span>
                </label>
              </div>
              <div class="switch-group" v-if="['radio'].includes(element.type)">
                <label class="caption">Vorfüllen</label>
                <label name="required" class="switch class pull-right">
                  <input
                    type="checkbox"
                    :checked="element.attributes.prefilled"
                    @click="onclickIsFiled()"
                    :disabled="!isUserHasAccess"
                  />
                  <span
                    class="slider round"
                    :disabled="!isUserHasAccess"
                  ></span>
                </label>
              </div>
              <div class="switch-group">
                <label class="caption">Feld sperren</label>
                <label name="required" class="switch class pull-right">
                  <input
                    type="checkbox"
                    :checked="element.attributes.disabled"
                    @click="onToggleElementDisabled"
                    :disabled="!isUserHasAccess"
                  />
                  <span
                    class="slider round"
                    :disabled="!isUserHasAccess"
                  ></span>
                </label>
              </div>

              <div
                class="switch-group"
                v-if="isChoiceWithAppearanceCard(element)"
              >
                <label class="caption">Bild im Hintergrund</label>
                <label name="required" class="switch class pull-right">
                  <input
                    type="checkbox"
                    :checked="isBackgroundImage"
                    @click="toggleImageBackGroundView()"
                    :disabled="!isUserHasAccess"
                  />
                  <span
                    class="slider round"
                    :disabled="!isUserHasAccess"
                  ></span>
                </label>
              </div>
              <div
                class="switch-group"
                v-if="isChoiceWithAppearanceCard(element)"
              >
                <label class="caption">Beschreibung hinzufügen</label>
                <label name="required" class="switch class pull-right">
                  <input
                    type="checkbox"
                    :checked="isShowDescription"
                    @click="toggleTitleDescriptionView()"
                    :disabled="!isUserHasAccess"
                  />
                  <span
                    class="slider round"
                    :disabled="!isUserHasAccess"
                  ></span>
                </label>
              </div>
              <div class="switch-group" v-if="element.type === 'html'">
                <label class="caption">HTML-Rendering</label>
                <label name="required" class="switch class pull-right">
                  <input
                    type="checkbox"
                    :checked="element.settings.isHtmlRendered"
                    @click="toggleHtmlRender"
                  />
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
            <div
              v-if="element.type === 'smartmessage'"
              class="btn"
              @click="$emit('writeMessage', element)"
            >
              <span>Schreiben</span>
            </div>

            <input
              v-show="false"
              type="submit"
              value="Submit"
              ref="submitBtn"
            />
          </form>
        </div>
      </div>
    </div>
    <CommonModal
      v-if="isRenameConfirmModalVisible"
      :buttons="[
        {
          text: 'Bestätigen',
          action: 'onConfirmRename',
          loading: false,
        },
        {
          text: 'stornieren',
          action: 'onCancelRename',
          loading: false,
        },
      ]"
      header="confirm-message"
      @onCancelRename="onCancelRename"
      @onConfirmRename="onConfirmRename"
    >
      <template v-slot:confirm-message>
        <div
          class="confirm-message-wrapper"
          v-html="nameUpdateWarningText"
        ></div>
      </template>
    </CommonModal>
    <CommonModal
      v-if="showcaseField.isVisible"
      :buttons="[
        {
          text: 'Ja',
          action: 'changeShowcaseField',
          loading: false,
        },
        {
          text: 'Abbrechen',
          action: 'cancelShowcaseField',
          loading: false,
        },
      ]"
      header="confirm-message"
      @cancelShowcaseField="cancelShowcaseField"
      @changeShowcaseField="changeShowcaseField"
    >
      <template v-slot:confirm-message>
        <div class="showcasefield-wrapper" v-html="showcaseField.html"></div>
      </template>
    </CommonModal>
    <CommonModal
      class="linkdb-confirm-modal"
      v-if="isShowLinkDBConfirmModal"
      :buttons="[
        {
          text: 'Element löschen',
          action: 'onDeleteElement',
          loading: false,
        },
        {
          text: 'Weiter bearbeiten',
          action: 'onContinueEdit',
          loading: false,
        },
      ]"
      header="confirm-message"
      @onDeleteElement="onDeleteLinkDbElement"
      @onContinueEdit="onToggleLinkDbConfirmModal"
    >
      <template v-slot:confirm-message>
        <div class="confirm-message-wrapper">
          <p class="confirm-message">
            Bitte wählen Sie eine Datenbank, ein Element und mindestens eine
            Spalte aus. Möchten Sie dieses Element löschen oder weiter
            bearbeiten?
          </p>
        </div>
      </template>
    </CommonModal>
  </div>
</template>

<script>
import FormBuilder from '../widgets/FormBuilderV2.vue';
import cards from '../widgets/cards.vue';
import FilePicker from '../core/FilePicker.vue';
import IconPicker from '../widgets/IconPicker.vue';
import GeneralDropdown from '../core/general-dropdown.vue';
import { mapGetters } from 'vuex';
import { getTableItems } from '../../services/userTable';
import NumberComponent from '../widgets/NumberComponent.vue';
import CommonModal from '@/components/modals/CommonModal.vue';
import SelectDatabase from '../../components/SelectDatabase.vue';
import moment from 'moment';
import {
  debouncer,
  getSliderValuePosition,
  getCheckboxMinMax,
  showInputInvalidCustomMessage,
  formatWithThousandSeparator,
  jsonParser,
} from '../../utils/helpers';
import { getDataBaseTableSchema } from '../../services/userTable';
import { getCustomDatabaseItems } from '../../services/axios/data.api.js';

import draggable from 'vuedraggable';

export default {
  name: 'elementProps',
  data() {
    return {
      selectedType: null,
      groupArrayIndex: null,
      invalidOptionName: false,
      lastUpdatedInvalidOptionValueIndexes: [],
      checked: null,
      shakeName: false,
      dropdownSelection: null,
      isValidatingProcess: false,
      nextElement: null,
      isMoreSettingsVisible: false,
      isErrorInForm: false,
      buildURLId: undefined,
      databaseItemsList: null,
      isDbItemListLoading: false,
      iconPickerURLId: undefined,
      selectedPreviewLabel: null,
      isPropsError: false,
      elementName: '',
      isRenameConfirmModalVisible: false,
      nameUpdateWarningText: null,
      isOverFlowHidden: false,
      databaseColumns: [],
      databaseColumnLoading: false,
      isShowLinkDBConfirmModal: false,
      selectedDatabaseColumn: [],
      lastUpdatedInvalidOptionIndexes: [],
      showcaseField: {
        isVisible: false,
        html: '',
        databaseShowField: {},
      },
      typeGroupingList: [
        [
          'text',
          'number',
          'formatted_number',
          'email',
          'textarea',
          'hidden',
          'range',
        ],
        ['date', 'datetime-local'],
        [
          'status',
          'radio',
          'radiooval',
          'radiocard',
          'checkbox',
          'checkboxoval',
          'checkboxcard',
        ],
      ],
    };
  },
  props: {
    typeList: { type: Array, default: [] },
    element: Object,
    elements: { type: Array, default: [] },
    existingNames: Array,
    reservedElementKeys: Array,
    isCreateCustomDB: Boolean,
    isEditMode: { type: Boolean, default: false },
    databaseMeta: {
      type: Object,
    },
    isUserHasAccess: { type: Boolean, default: true },
    selectedDatabase: {
      type: Object,
      default: () => null,
    },
    taskName: {
      type: String,
      required: false,
      default: '',
    },
    importedSchemaElementIds: { type: Array, default: () => [] },
  },
  methods: {
    normalizeTsType(itemType) {
      return String(itemType || '').toLowerCase();
    },
    isValidTsType(itemType) {
      const normalizedTsType = this.normalizeTsType(itemType);
      return (
        normalizedTsType.includes('loadcurve') ||
        normalizedTsType.includes('timeseries')
      );
    },
    onDatabaseItemChange(dbItem) {
      this.element.value = dbItem.id;
      this.$emit('requestValidation');
    },
    async selectDatabaseLink(db, shouldClearValue) {
      try {
        this.isDbItemListLoading = true;
        if (shouldClearValue) {
          this.element.value = null;
        }
        if (this.element.type === 'databaselinkedview') {
          this.element.settings.connectedDatabase.selectedDatabaseCaption =
            db.caption;
          this.element.settings.connectedDatabase.selectedDatabaseID = db.name;
          this.element.settings.connectedDatabase.selectedDatabaseType =
            db.type;
        }
        this.element.selectedDatabaseCaption = db.caption;
        this.element.selectedDatabaseID = db.name;
        this.element.selectedDatabaseType = db.type;
        if (
          this.databaseItemsList &&
          this.databaseItemsList[this.element.selectedDatabaseID]
        ) {
          this.isDbItemListLoading = false;
          this.$emit('requestValidation');
          return;
        } else {
          let params = '';
          if (this.element.type === 'linktodb' && db.type === 'custom') {
            const findDatabase = this.getDatabaseList.find(
              (database) => database.name === db.name
            );
            let schema;
            if (findDatabase && findDatabase.schema) {
              schema = JSON.parse(findDatabase.schema);
            } else {
              const response = await getDataBaseTableSchema(db.name, true);
              if (response && response.status === 200 && response.data) {
                this.$store.commit('SET_DATABASE_SCHEMA', response.data);
                schema = JSON.parse(response.data.data);
              }
            }
            const findShowcaseField = schema.find(
              (el) => el?.settings?.showcaseField
            );
            if (findShowcaseField) {
              this.showcaseField.databaseShowField[db.name] = findShowcaseField;
              params = '?keys=' + findShowcaseField.name;
            }
          }
          const listItems = await getCustomDatabaseItems(db.name, params, true);
          if (
            listItems &&
            listItems.status === 200 &&
            listItems.data &&
            listItems.data.items
          ) {
            let databaseItems;
            if (db.type === 'loadprofile') {
              const filteredData = [...listItems.data.items].filter(
                (el) => el.id.includes('sheet') && this.isValidTsType(el.ts_type)
              );
              databaseItems = filteredData;
            } else {
              databaseItems = listItems.data.items;
            }
            this.databaseItemsList = this.databaseItemsList
              ? {
                  ...this.databaseItemsList,
                  [this.element.selectedDatabaseID]: databaseItems,
                }
              : { [this.element.selectedDatabaseID]: databaseItems };
          }

          this.isDbItemListLoading = false;
          this.$emit('requestValidation');
        }
      } catch (error) {
        // eslint-disable-next-line
        console.log(error);
        this.isDbItemListLoading = false;
        this.element.settings.connectedDatabase.selectedDatabaseCaption = null;
        this.element.settings.connectedDatabase.selectedDatabaseID = null;
        this.element.settings.connectedDatabase.selectedDatabaseType = null;
      }
    },
    toggleCloseModal() {
      this.$emit('close');
    },
    checkboxValidation(element) {
      let totalChecked = element.options.filter(
        (option) => option.checked
      ).length;
      let checkBoxMinMaxValue = getCheckboxMinMax(element);
      if (checkBoxMinMaxValue.min > checkBoxMinMaxValue.max) {
        return false;
      }
      if (totalChecked < checkBoxMinMaxValue.min) {
        this.showToaster(
          `Es dürfen mindestens ${checkBoxMinMaxValue.min}“ Auswahlen ausgewählt werden.`,
          'Fehlerhaft !',
          'danger'
        );
        return false;
      } else if (
        checkBoxMinMaxValue.max !== '' &&
        totalChecked > checkBoxMinMaxValue.max
      ) {
        this.showToaster(
          `Es dürfen maximal ${checkBoxMinMaxValue.max} Auswahlen ausgewählt werden.`,
          'Fehlerhaft !',
          'danger'
        );
        return false;
      }
      return true;
    },
    handleSubmission() {
      if (this.element.name == 'props') {
        this.isPropsError = true;
        return false;
      }

      if (this.element.type === 'objectlist') {
        for (const elem of this.element.schema) {
          if (
            elem.type === 'checkbox' &&
            elem.attributes.required &&
            !elem.attributes.disabled
          ) {
            const isValidate = this.checkboxValidation(elem);
            if (!isValidate) {
              return isValidate;
            }
          }
        }
      } else if (
        this.element.type === 'checkbox' &&
        this.element.attributes.required &&
        !this.element.attributes.disabled
      ) {
        const isValidate = this.checkboxValidation(this.element);

        if (!isValidate) {
          return isValidate;
        }
      } else if (this.element.type === 'databaselinkedview') {
        if (this.element?.settings?.connectedDatabase?.selectedDatabaseColumn) {
          this.element.settings.connectedDatabase.selectedDatabaseColumn =
            this.selectedDatabaseColumn;
        }
        if (
          this.selectedDatabaseColumn.length === 0 ||
          this.element?.settings?.connectedDatabase?.selectedDatabaseID ===
            undefined ||
          (this.getSelectedDatabaseFields.length !== 0 &&
            this.element?.databaseLink?.currentTableFieldKey === undefined)
        ) {
          this.onToggleLinkDbConfirmModal();
          return false;
        }
      }

      if (this.checkUserNameChanged()) return false;
      if (!this.nameAlreadyExists) {
        if (this.isErrorInForm) return false;
        else if (this.isValidatingProcess) {
          this.elementName = this.nextElement.name;
          this.$emit('changeElement', this.nextElement);
        } else {
          this.toggleCloseModal();
        }
      }
    },
    close() {
      if (this.isCreateCustomDB) {
        this.element.label = this.element.label.trim();
      }

      this.isValidatingProcess = false;

      this.handleChoicesValues();
      setTimeout(() => {
        this.$refs.submitBtn.click();
      }, 0);
    },
    formSubmit(element) {
      this.isValidatingProcess = true;
      this.nextElement = element;
      this.$refs.submitBtn.click();
    },
    handleChoicesValues() {
      let el = this.element;
      if (['radio', 'status'].includes(el.type)) {
        let checked = el.options.find((e) => e.checked);
        el.value = checked != undefined ? checked.value : '';
      } else if (el.type === 'checkbox') {
        el.value = el.options.filter((e) => e.checked).map((e) => e.value);
      }
    },
    addOption() {
      var newOption = this.$refs.newOption.value;
      const normalizedNewOption = newOption.trim();
      const optionValueExists =
        this.element.type === 'status' &&
        this.element.options.some(
          (option) => String(option.value ?? '').trim() === normalizedNewOption
        );

      if (
        !this.optionNameExists(normalizedNewOption) &&
        !optionValueExists
      ) {
        if (normalizedNewOption != '') {
          const option = {
            label: normalizedNewOption,
            value: normalizedNewOption,
            checked: false,
          };

          // Handle img-tag for card options
          if (this.isCardItem) option.img = '';
          const hasCheckedOption = this.element.options.find((e) => e.checked);
          this.element.options.push(option);

          if (!hasCheckedOption && this.element.options.length > 0) {
            this.element.options.forEach((e) => (e.checked = false));
            this.element.options[0].checked = true;
            if (['radio', 'status'].includes(this.element.type))
              this.element.value = this.element.options[0].label;
            else if (this.element.type === 'checkbox')
              this.element.value.push(this.element.options[0].label);

            if (this.element.settings.max == 0) {
              this.element.settings.max = 1;
            }
          }

          this.validateOptions();
          this.$refs.newOption.value = '';
          this.invalidOptionName = false;
          this.isErrorInForm = false;
        }
      } else {
        this.invalidOptionName = true;
        this.isErrorInForm = true;
      }
    },
    optionNameExists(optionName) {
      return (
        this.element.options.filter((o) => o.label === optionName).length > 0
      );
    },
    changeChecked: function (o, type) {
      if (type === 'radio' || type === 'status') {
        this.element.options.forEach((e) => {
          e.checked = false;
        });
        o.checked = true;
        this.element.value = o.value;
        if (!this.element.attributes.prefilled) {
          this.element.attributes.prefilled = true;
        }
      } else if (type === 'checkbox') {
        o.checked = !o.checked;
        if (o.checked) this.element.value.push(o.value);
        else
          this.element.value = this.element.value.filter((e) => e != o.value);
      } else if (type === 'select') {
        this.selectedPreviewLabel = o.label;
        if (this.element.default) {
          this.element.value = o.value;
        }
      }
    },
    getFiles(event) {
      this.element.files = event.target.files;

      setTimeout(() => {
        this.$emit('onFileChange', this.element);
      }, 100);
    },
    isInputRequired(type) {
      const typesWithInput = [
        'text',
        'email',
        'location',
        'date',
        'datetime-local',
        'hidden',
        'model',
      ];
      return typesWithInput.includes(type);
    },
    isElementValueRequired(element) {
      return this.isCreateCustomDB ? false : element.attributes.required;
    },
    isPlaceholderRequired: function (type) {
      const typesWithPlaceholder = [
        'text',
        'email',
        'number',
        'textarea',
        'smartmessage',
        'formatted_number',
      ];
      return typesWithPlaceholder.includes(type);
    },

    // This function is important if the user uses CopyPaste
    transformName() {
      this.element.name = this.element.name.toLowerCase();
    },
    validateOptions() {
      if (!Array.isArray(this.element?.options)) return;

      const labelCountMap = {};
      const valueCountMap = {};
      this.element.options.forEach((opt) => {
        const normalizedLabel = opt.label ?? '';
        const normalizedValue = opt.value ?? '';
        labelCountMap[normalizedLabel] =
          (labelCountMap[normalizedLabel] || 0) + 1;
        if (this.element.type === 'status') {
          valueCountMap[normalizedValue] =
            (valueCountMap[normalizedValue] || 0) + 1;
        }
      });
      this.lastUpdatedInvalidOptionIndexes = this.element.options
        .map((opt, idx) => ({ label: opt.label, value: opt.value, idx }))
        .filter(({ label, value }) => labelCountMap[label] > 1 || !label)
        .map(({ idx }) => idx);
      this.lastUpdatedInvalidOptionValueIndexes = this.element.options
        .map((opt, idx) => ({ label: opt.label, value: opt.value, idx }))
        .filter(({ value }) =>
          this.element.type === 'status'
            ? valueCountMap[value] > 1 || !String(value).trim()
            : false
        )
        .map(({ idx }) => idx);
      this.isErrorInForm = Boolean(
        this.invalidOptionName ||
          this.lastUpdatedInvalidOptionIndexes.length ||
          this.lastUpdatedInvalidOptionValueIndexes.length
      );
    },
    removeElement(option, index) {
      if (!this.isUserHasAccess) return;

      if (this.selectedPreviewLabel == option.label) {
        this.selectedPreviewLabel = null;
      }

      this.element.options = this.element.options.filter((el) => {
        return el != option;
      });
      this.validateOptions();

      if (this.element.type === 'checkbox') {
        this.element.settings.max = this.element.options.length;
        this.element.value = this.element.options
          .filter((option) => option.checked)
          .map((option) => option.label);
      }
      if (['radio', 'status'].includes(this.element.type) && option?.checked) {
        this.element.value = '';
      }
    },
    getLabelCaption(type) {
      let captions = {
        file: 'Datei',
        filenew: 'Datei New',
        email: 'E-Mail Adresse',
        number: 'Zahl',
        formatted_number: 'Zahl',
        model: 'Model',
        range: 'Zahl',
        timestampms: 'Zeitstempel',
      };

      const sameCaptionForTheSomeTypes = [
        'textarea',
        'text',
        'hidden',
        'html',
        'date',
        'datetime-local',
      ];

      if (captions[type] != undefined) return captions[type];
      if (sameCaptionForTheSomeTypes.includes(type)) return 'Beispiel';
      return false;
    },
    saveListSchema(schema) {
      this.element.schema = schema;
    },
    isExampleFieldLabel(type) {
      return ['smartmessage'].includes(type);
    },
    isExampleFieldTextarea(type) {
      return ['smartmessage'].includes(type);
    },
    onFileSelected(file) {
      this.$emit('onFileSelected', file);
    },
    onFileDelete() {
      this.$emit('onFileDelete', this.element);
    },
    updateLinkType(type, i) {
      if (i || i == 0) this.$set(this.element.options[i], 'linkType', type);
      else this.$set(this.element, 'linkType', type);
    },

    toggleIconPickerURL(id) {
      if ((!id && id != 0) || this.iconPickerURLId == id)
        this.iconPickerURLId = undefined;
      else this.iconPickerURLId = id;
    },
    updateUrl(icon, i) {
      if (i || i == 0) this.$set(this.element.options[i], 'img', icon);
      else this.$set(this.element, 'url', icon);
    },
    onSheetFileSelect(event) {
      this.$emit('onSheetFileSelect', event.target.files[0]);
    },
    toggleTitleDescriptionView() {
      this.element.attributes.isShowTitleAndDescription =
        !this.isShowDescription;
      if (this.isShowDescription === false) {
        this.element.options.forEach((option) => {
          option.description = '';
        });
      }
    },
    toggleImageBackGroundView() {
      this.element.attributes.isImgShowInBackGround = !this.isBackgroundImage;
    },
    isChoiceWithAppearanceCard(element) {
      return (
        ['radio', 'status', 'checkbox'].includes(element.type) &&
        element.attributes.appearance === 'card'
      );
    },
    onNumberComponentInputChange(newValue) {
      this.element.value = newValue;
    },
    toggleErrorInForm(newValue) {
      this.isErrorInForm = newValue;
    },
    isNumberRangeVisible(type) {
      return ['range', 'number'].includes(type);
    },

    toggleHighlight() {
      if (this.isElementHasSettings)
        this.element.settings.highlight = !this.element.settings.highlight;

      this.element.highlight = !this.element.highlight;
    },
    toggleDefault() {
      if (this.isElementHasSettings)
        this.element.settings.default = !this.element.settings.default;

      this.element.default = !this.element.default;
    },

    getElementSettings(key) {
      if (this.isElementHasSettings) {
        return this.element.settings.hasOwnProperty(key)
          ? this.element.settings[key]
          : null;
      } else {
        return this.element.hasOwnProperty(key) ? this.element[key] : null;
      }
    },
    handleOptionValue(option, index) {
      if (String(option.value ?? '').trim() !== '') {
        const hasDuplicateStatusValue =
          this.element.type === 'status' &&
          this.lastUpdatedInvalidOptionValueIndexes.includes(index);
        if (
          this.invalidOptionName ||
          this.lastUpdatedInvalidOptionIndexes.length ||
          hasDuplicateStatusValue
        )
          this.isErrorInForm = true;
        else this.isErrorInForm = false;
        return hasDuplicateStatusValue;
      } else {
        this.isErrorInForm = true;
        return true;
      }
    },
    changeOption(e, index) {
      const changedOptionValue = e.target.value;
      const isUniqueKey =
        this.element.options.filter(
          (option, optionIndex) =>
            option.label === changedOptionValue.trim() && optionIndex != index
        ).length > 0;
      if (this.element.options[index].checked) {
        if (['radio', 'status'].includes(this.element.type))
          this.element.value = changedOptionValue;
        else if (this.element.type === 'checkbox')
          this.element.value = this.element.options
            .filter((option) => option.checked)
            .map((option) => option.label);
      }
      if (isUniqueKey) {
        this.lastUpdatedInvalidOptionIndexes.push(index);
        this.isErrorInForm = true;
      } else {
        if (changedOptionValue.trim() == '') {
          this.lastUpdatedInvalidOptionIndexes.push(index);
          this.isErrorInForm = true;
        } else {
          this.lastUpdatedInvalidOptionIndexes =
            this.lastUpdatedInvalidOptionIndexes.filter(
              (optionIndex) => optionIndex != index
            );
          if (!this.lastUpdatedInvalidOptionIndexes.length) {
            this.isErrorInForm = false;
          }
        }
      }
      this.validateOptions();
    },
    setType() {
      this.typeDropdownItems.forEach((group, index) => {
        if (['radio', 'status', 'checkbox'].includes(this.element.type)) {
          if (this?.element?.attributes?.appearance) {
            const appearance = this.element.attributes.appearance;
            if (appearance === 'card') {
              this.selectedType = ['radio', 'status'].includes(
                this.element.type
              )
                ? 'radiocard'
                : 'checkboxcard';
            } else if (appearance === 'oval') {
              this.selectedType = ['radio', 'status'].includes(
                this.element.type
              )
                ? 'radiooval'
                : 'checkboxoval';
            }
          } else {
            this.selectedType = this.element.type;
          }
          this.groupArrayIndex = index;
          return;
        } else {
          group.forEach((type) => {
            if (type === this.element.type) {
              this.selectedType = this.element.type;
              this.groupArrayIndex = index;
              return;
            }
          });
        }
      });
    },
    changeElementType(type) {
      this.selectedType = type;

      if (this.isImportedElement) {
        this.groupArrayIndex = this.typeDropdownItems.findIndex((group) =>
          group.includes(type)
        );
        if (Array.isArray(this.element.value)) {
          this.element.value = this.element.value[0] || '';
        }
      }
      if (type === 'select') {
        this.element.attributes = {
          disabled: this.element?.attributes?.disabled || false,
          required: this.element?.attributes?.required || false,
          tabindex: this.element?.attributes?.tabindex || '',
          appearance: 'oval',
          'v-model': 'picked',
        };
        this.$set(this.element, 'options', this.element.options || []);

        if (!this.element.options.length && this.element.value) {
          this.$set(this.element.options, 0, {
            checked: true,
            label: String(this.element.value),
            value: String(this.element.value),
          });
        }
      } else if (this.groupArrayIndex === 0) {
        this.element.options = [];
        this.element.attributes = {
          disabled: this.element?.attributes?.disabled || false,
          required: this.element?.attributes?.required || false,
          tabindex: this.element?.attributes?.tabindex || '',
        };
        if (type === 'number' || type === 'formatted_number') {
          if (type === 'formatted_number') {
            this.element.settings = {
              ...this.element.settings,
              thSep: '.',
              decSep: ',',
              toFixed: 2,
            };
          }
          if (!String(this.element.value).match(/^[0-9]*\.?[0-9]+$/)) {
            this.element.value = 1;
          } else {
            this.element.value = Number(this.element.value);
          }
        } else if (type === 'range') {
          if (!String(this.element.value).match(/^(?:100|[1-9][0-9]?)$/)) {
            this.element.value = 15;
          } else {
            this.element.value = Number(this.element.value);
          }
          this.element.attributes = {
            min: 1,
            max: 100,
            required: false,
          };
        }
        if (
          type !== 'formatted_number' &&
          (this.element?.settings?.hasOwnProperty('toFixed') ||
            this.element?.settings?.hasOwnProperty('decSep') ||
            this.element?.settings?.hasOwnProperty('thSep'))
        ) {
          delete this.element.settings.toFixed;
          delete this.element.settings.decSep;
          delete this.element.settings.thSep;
        }
      } else if (this.groupArrayIndex === 1) {
        this.element.options = [];
        if (type === 'date') {
          this.element.value = this.element.value.substring(0, 10);
        } else if (type === 'datetime-local') {
          this.element.value = `${this.element.value}T01:00`;
        }
      } else if (this.groupArrayIndex === 2) {
        const find = this.typeList.find((elem) => {
          return elem.name === type;
        });
        if (find) {
          this.element.attributes = {
            required: this.element.attributes.required,
            disabled: this.element.attributes.disabled,
            tabindex: this.element.attributes.tabindex,
            ...(['checkboxcard', 'radiocard'].includes(type) &&
              this.element.attributes.hasOwnProperty(
                'isImgShowInBackGround'
              ) && {
                isImgShowInBackGround:
                  this.element.attributes.isImgShowInBackGround,
              }),
            ...(['checkboxcard', 'radiocard'].includes(type) &&
              this.element.attributes.hasOwnProperty(
                'isShowTitleAndDescription'
              ) && {
                isShowTitleAndDescription:
                  this.element.attributes.isShowTitleAndDescription,
              }),
          };
          if (find.element.attributes) {
            this.element.attributes = {
              ...find.element.attributes,
              ...this.element.attributes,
            };
          }
          for (const option of this.element.options) {
            if (
              ['checkboxcard', 'radiocard'].includes(type) &&
              !option.hasOwnProperty('img')
            ) {
              option.img = '';
            } else if (!['checkboxcard', 'radiocard'].includes(type)) {
              option.hasOwnProperty('img') && delete option.img;
              option.hasOwnProperty('linkType') && delete option.linkType;
              option.hasOwnProperty('description') && delete option.description;
            }
          }
          if (this.isImportedElement) {
            this.element.type = [
              'radio',
              'status',
              'radiooval',
              'radiocard',
            ].includes(type)
              ? 'checkbox'
              : 'radio';
            if (this.element.type === 'checkbox' && this.element.value) {
              this.element.value = [this.element.value];
            }

            this.$set(this.element, 'options', this.element.options || []);

            if (!this.element.options.length && this.element.value) {
              this.$set(this.element.options, 0, {
                checked: true,
                label: String(this.element.value),
                value: String(this.element.value),
              });
            }
          }
          if (['radio', 'status', 'radiooval', 'radiocard'].includes(type)) {
            if (
              this.element.type === 'checkbox' &&
              this.element.options.length
            ) {
              const optionCheckedLength = this.element.options.filter(
                (option) => option.checked
              ).length;
              if (optionCheckedLength >= 2) {
                //when 2 or more than 2 checkbox is selected
                this.element.options.forEach((option, index) => {
                  if (index === 0) {
                    option.checked = true;
                  } else {
                    option.checked = false;
                  }
                });
                this.element.value = this.element.options[0].label;
              } else if (optionCheckedLength === 0) {
                //when no checkbox is selected
                this.element.options[0].checked = true;
                this.element.value = this.element.options[0].label;
              } else {
                //when only one checkbox is selected
                this.element.value = this.element.value[0];
              }
              if (
                this.element?.settings?.hasOwnProperty('min') ||
                this.element?.settings?.hasOwnProperty('max')
              ) {
                delete this.element.settings.min;
                delete this.element.settings.max;
              }
            }
            this.element.type = type === 'status' ? 'status' : 'radio';
          } else if (
            ['checkbox', 'checkboxcard', 'checkboxoval'].includes(type)
          ) {
            if (['radio', 'status'].includes(this.element.type)) {
              this.element.settings = {
                ...this.element.settings,
                min: 0,
                max: this.element.options.length,
              };
              this.element.value = [this.element.value];
            }
            this.element.type = 'checkbox';
          }

          this.validateOptions();
          this.$forceUpdate();
        }
        return;
      }
      this.element.type = type;
    },

    async onSelectLinkedViewDatabase(database) {
      this.isDbItemListLoading = true;
      this.element.settings.connectedDatabase.selectedDatabaseCaption =
        database.caption;
      this.element.settings.connectedDatabase.selectedDatabaseID =
        database.name;
      this.element.settings.connectedDatabase.selectedDatabaseType =
        database.type;
      this.isDbItemListLoading = false;
      await this.setDatabaseLinkedViewSchema(database);
      const selectedColumn = [];
      const defaultColumn =
        this.databaseColumns.length < 5 ? this.databaseColumns.length : 5;
      for (let i = 0; i < defaultColumn; i++) {
        const element = this.databaseColumns[i];
        selectedColumn.push(element.name);
      }
      this.selectedDatabaseColumn = selectedColumn;
      this.$emit('requestValidation');
    },
    onSelectDatabseLinkedtoViewKey(item) {
      this.element.databaseLink.currentTableFieldKey = item.name;
      this.element.databaseLink.currentTableFieldCaption = item.label;
      this.$emit('requestValidation');
    },
    validateInput(event, isDecimal) {
      const regex = /^[,.']*$/;
      let currentValue = event.target.value;
      let checkInput = regex.test(currentValue);
      if (currentValue !== '' && checkInput) {
        if (isDecimal && currentValue === this.element.settings.thSep) {
          this.element.settings.decSep =
            this.element.settings.thSep !== ',' ? ',' : '.';
          this.showDecThErrorToaster();
          return;
        } else if (
          !isDecimal &&
          currentValue === this.element.settings.decSep
        ) {
          this.element.settings.thSep =
            this.element.settings.decSep !== '.' ? '.' : ',';
          this.showDecThErrorToaster();
          return;
        }
      }
      if (!checkInput || currentValue.length > 1) {
        isDecimal
          ? (this.element.settings.decSep = '')
          : (this.element.settings.thSep = '');
      }
    },

    getFormatNumber() {
      return {
        thousandseparator: this.element?.settings?.thSep ?? '.',
        decimalseparator: this.element?.settings?.decSep ?? ',',
      };
    },
    showDecThErrorToaster() {
      this.showToaster(
        'Tausendertrennzeichen und Dezimaltrennzeichen dürfen nicht identisch sein',
        'Fehlerhaft !',
        'danger'
      );
    },
    showToaster(message, title, variant) {
      this.$bvToast.toast(message, {
        title,
        variant,
      });
    },
    setRangePosition(elementID) {
      const slider = this.$refs[`rangeInput${elementID}`];
      const label = this.$refs[`rangeoutput${elementID}`];
      if (slider !== undefined && label !== undefined) {
        const position = getSliderValuePosition(slider, label);
        label.style.left = `${position - 12}px`;
      }
    },
    updateValue(e, id) {
      debouncer(
        () => {
          if (this.element.attributes.min > this.element.value) {
            this.element.value = this.element.attributes.min;
            this.updateRangePosition(id);
          } else if (this.element.attributes.max < this.element.value) {
            this.element.value = this.element.attributes.max;
            this.updateRangePosition(id);
          }
        },
        300,
        this,
        'checkElementValue'
      );
      this.updateRangePosition(id);
    },
    updateRangePosition(id) {
      setTimeout(() => {
        this.setRangePosition(id);
      }, 0);
    },
    onConfirmRename() {
      this.elementName = this.element.name;
      this.isRenameConfirmModalVisible = false;
      this.$emit('addElementAfterConfirm');
      this.toggleCloseModal();
    },
    onCancelRename() {
      this.element.name = this.elementName;
      this.isRenameConfirmModalVisible = false;
      this.$emit('removeElementAfterCancle');
    },
    updateDatabaseLinkedViewCaption() {
      const findDatabaseLinkedView = this.elements.find(
        (el) =>
          el.type === 'databaselinkedview' &&
          this.element.name === el.databaseLink.currentTableFieldKey
      );
      if (findDatabaseLinkedView) {
        findDatabaseLinkedView.databaseLink.currentTableFieldCaption =
          this.element.label;
      }
      return true;
    },
    showScrollbar(event) {
      event.target.classList.add('show-scrollbar');
      debouncer(
        () => {
          event.target.classList.remove('show-scrollbar');
        },
        300,
        this,
        'removeScrollClass'
      );
    },
    onclickIsRequired() {
      this.element.attributes.required = !this.element.attributes.required;
      if (this.element.type === 'checkbox') {
        if (this.element.attributes.required) {
          this.element.settings.min = 1;
          this.element.settings.max = this.element.options.length;
        } else {
          this.element.settings.min = 0;
          this.element.settings.max = 0;
        }
      }
      this.$nextTick(() => {
        this.$refs?.textInputRef?.setCustomValidity('');
        this.$refs?.textareaInputRef?.setCustomValidity('');
        this.$refs?.numberInputRef?.setCustomValidity('');
        this.$refs?.numberComponentRef?.$refs?.formateNumberInputRef?.setCustomValidity(
          ''
        );
      });
    },
    onclickIsFiled() {
      this.element.attributes.prefilled = !this.element.attributes.prefilled;
      if (this.element.attributes.prefilled && this.element.options[0]) {
        this.element.options[0].checked = true;
      } else {
        this.element.options.forEach((e) => {
          e.checked = false;
        });
      }
    },

    onToggleElementDisabled() {
      this.$set(
        this.element.attributes,
        'disabled',
        !Boolean(this.element.attributes.disabled)
      );
    },
    onMinValueChange(element) {
      const checkBoxMinMaxValue = getCheckboxMinMax(element);
      if (checkBoxMinMaxValue.min > 0) {
        this.element.attributes.required = true;
        if (this.element.settings.max === 0) {
          this.element.settings.max = this.element.options.length;
        }
      } else {
        this.element.attributes.required = false;
      }
    },
    isCheckboxMinError(element) {
      const checkBoxMinMaxValue = getCheckboxMinMax(element);
      return (
        checkBoxMinMaxValue.min !== '' &&
        ((checkBoxMinMaxValue.max !== '' &&
          checkBoxMinMaxValue.min > checkBoxMinMaxValue.max) ||
          checkBoxMinMaxValue.min < 0 ||
          checkBoxMinMaxValue.min > this.element.options.length)
      );
    },
    isCheckBoxMaxError(element) {
      const checkBoxMinMaxValue = getCheckboxMinMax(element);
      return (
        checkBoxMinMaxValue.max !== '' &&
        (checkBoxMinMaxValue.max < 0 ||
          checkBoxMinMaxValue.max > this.element.options.length)
      );
    },
    isRangeMinMaxInputError() {
      const isInvalidInput =
        this.element.attributes.min &&
        this.element.attributes.max &&
        Number(this.element.attributes.min) >=
          Number(this.element.attributes.max);

      if (isInvalidInput) {
        this.toggleErrorInForm(true);
      } else {
        if (!this.element.attributes.max || !this.element.attributes.min)
          this.toggleErrorInForm(true);
        else this.toggleErrorInForm(false);
      }

      return isInvalidInput;
    },
    isElementTypeRange(element) {
      return element.type === 'range';
    },
    objectListModalWatch(bool) {
      if (bool) {
        const scrollEle = this.$refs.elementPropModalRef;
        if (scrollEle) {
          scrollEle.scrollTop = 0;
        }
      }
      this.isOverFlowHidden = bool;
    },

    triggerFileReupload() {
      if (this.element.type === 'file' && this.element.files?.length) {
        const inputElement = this.$refs.fileInput;
        inputElement.files = this.element.files;
      }
    },
    selectDatabaseFromDropdown(database) {
      delete this.showcaseField.databaseShowField[database];
      this.selectDatabaseLink(database, true);
    },
    async setDatabaseLinkedViewSchema(database) {
      try {
        this.databaseColumnLoading = true;
        let databaseSchema = database.schema;
        if (databaseSchema) {
          databaseSchema = JSON.parse(databaseSchema);
        } else {
          const findDatabase = await this.getDatabaseLinkedViewTableSchema(
            database.name
          );
          databaseSchema = JSON.parse(findDatabase.data);
        }
        this.databaseColumns = databaseSchema.map((schema) => {
          return { name: schema.name, label: schema.label };
        });
      } catch (error) {
        this.databaseColumns = [];
      } finally {
        this.databaseColumnLoading = false;
      }
    },
    async getDatabaseLinkedViewTableSchema(name) {
      try {
        const response = await getDataBaseTableSchema(name, true);
        if (response && response.status === 200 && response.data) {
          this.$store.commit('SET_DATABASE_SCHEMA', response.data);
        }
        return response.data;
      } catch (error) {
        throw new Error(error);
      }
    },
    databaseLinkedViewColumnSelect(column) {
      if (this.selectedDatabaseColumn.length >= 15) {
        this.showToaster(
          'Sie können bis zu 15 Spalten auswählen.',
          'Fehlerhaft !',
          'danger'
        );
        return;
      }
      this.selectedDatabaseColumn.push(column);
      this.$emit('requestValidation');
    },

    databaseLinkedViewRemoveColumn(name) {
      const findIndex = this.selectedDatabaseColumn.indexOf(name);
      if (findIndex !== -1) {
        this.selectedDatabaseColumn.splice(findIndex, 1);
        this.$emit('requestValidation');
      }
    },
    setDatabaseLinkedViewCols() {
      if (this.element.type === 'databaselinkedview') {
        this.element.settings.connectedDatabase.selectedDatabaseColumn =
          this.selectedDatabaseColumn;
      }
    },
    databaseLinkedViewColumnLabel(name) {
      return this.databaseColumns.find((col) => col.name === name)?.label;
    },
    showToaster(message, title, variant) {
      this.$bvToast.toast(message, {
        title,
        variant,
      });
    },
    getNumberRangeElementMinMax(element, rangeType) {
      const adjustmentValue = rangeType == 'max' ? -1 : 1;
      if (element.type == 'range') {
        return Number(element.attributes[rangeType]) + adjustmentValue;
      } else {
        return (
          element.attributes[rangeType] &&
          Number(element.attributes[rangeType]) + adjustmentValue
        );
      }
    },
    toggleHtmlRender() {
      this.element.settings.isHtmlRendered =
        !this.element.settings.isHtmlRendered;
    },
    checkUserNameChanged() {
      if (
        !this.selectedDatabase &&
        this.isCreateCustomDB &&
        this.getSavedElementIds.includes(this.element.id) &&
        this.element.name !== this.elementName
      ) {
        this.nameUpdateWarningText =
          '<p class="confirm-message">Sie sind dabei, den Namen eines Elements zu ändern. Der Name ist eine eindeutige Kennung. Vorhandene Elemente in der Datenbank werden nicht aktualisiert.</p>';
        if (
          this.isDatabaseLinkedViewExistInElement &&
          this.getDatabaseLinkeViewKeys.includes(this.elementName)
        ) {
          this.nameUpdateWarningText = `<p class="confirm-message">Der Elementname <b> ${this.elementName} </b> wird in der
              datenbankverknüpften Ansicht verwendet. Sind Sie sicher, dass Sie
              die Änderung vornehmen möchten?</p>`;
        }
        this.isRenameConfirmModalVisible = true;
        return true;
      }
      return false;
    },
    onclickTodayAsDefaultValue() {
      this.element.attributes.todayAsDefaultValue =
        !this.element.attributes.todayAsDefaultValue;
      if (this.element.attributes.todayAsDefaultValue) {
        this.element.value =
          this.element.type === 'date'
            ? moment().format('YYYY-MM-DD')
            : moment().format('YYYY-MM-DDTHH:mm');
      }
    },
    toggleShowcaseField() {
      this.toggleShowcaseFieldValue(!this.element.settings.showcaseField);
      if (this.element.settings.showcaseField) {
        const findShowcaseFieldElem = this.elements.find(
          (el) => el?.settings?.showcaseField && el.name !== this.element.name
        );
        if (findShowcaseFieldElem) {
          this.showcaseField.html = `Achtung – Das Feld
          <b>${findShowcaseFieldElem.label}</b> ist derzeit als
          Verknüpfungslabel konfiguriert. Wenn Sie die Anpassung vornehmen, wird
          das bestehende Verknüpfungslabel überschrieben, und die Änderung wirkt
          sich sofort auf alle verknüpften Datenbanken aus.`;
          this.toggleShowcaseFieldModal(true);
          return;
        }
      }
    },
    addValidationMessage(e) {
      if (
        this.element?.attributes?.pattern &&
        this.element?.attributes?.errorMessage
      ) {
        if (e.target?.validity?.patternMismatch) {
          e.target.setCustomValidity(this.element?.attributes?.errorMessage);
        } else {
          e.target.setCustomValidity('');
        }
      } else {
        this.handleInputValidation(e);
      }
    },

    setDefaultSelectableItemOptions() {
      if (['radio', 'status', 'checkbox'].includes(this.element.type)) {
        if (
          this.element.options.length &&
          !this.element.options[0].hasOwnProperty('value')
        ) {
          this.element.options = this.element.options.map((option) => ({
            ...option,
            value: option.label,
          }));
        }
      }
    },

    isSelectableElements(elementType) {
      return ['checkbox', 'radio', 'status', 'select'].includes(elementType);
    },
    isRadioOrCheckboxElement(elementType) {
      return ['checkbox', 'radio', 'status'].includes(elementType);
    },
    handleInputValidation(event) {
      showInputInvalidCustomMessage(event);
    },
    onNumberRangeInputValueChange(event, element) {
      if (element.type === 'range') {
        this.setRangePosition(element.id);
      } else {
        this.handleInputValidation(event);
      }
    },
    onNumberRangeInputMinMaxChange(event, element) {
      if (element.type === 'range') {
        this.updateValue(event, element.id);
      } else {
        this.$refs?.numberInputRef?.setCustomValidity('');
      }
    },
    onTextPatternChange() {
      this.$refs?.textInputRef?.setCustomValidity('');
    },
    changeShowcaseField() {
      for (const element of this.elements) {
        element.settings.showcaseField = false;
      }
      this.toggleShowcaseFieldValue(true);
      this.toggleShowcaseFieldModal(false);
    },
    cancelShowcaseField() {
      this.toggleShowcaseFieldModal(false);
      this.$refs.showcaseField.click();
      setTimeout(() => {});
    },
    toggleShowcaseFieldModal(toggle) {
      this.showcaseField.isVisible = toggle;
    },
    toggleShowcaseFieldValue(toggle) {
      this.element.settings.showcaseField = toggle;
    },
    getLinktoDbValue(itemId) {
      if (itemId) {
        if (
          this.databaseItemsList &&
          this.databaseItemsList[this.element.selectedDatabaseID]
        ) {
          const findData = this.databaseItemsList[
            this.element.selectedDatabaseID
          ].find((item) => item.id === itemId);

          if (findData && this.element.selectedDatabaseType === 'loadprofile') {
            return findData.name;
          }
          if (
            findData &&
            this.showcaseField.databaseShowField[
              this.element.selectedDatabaseID
            ]
          ) {
            return (
              findData[
                this.showcaseField.databaseShowField[
                  this.element.selectedDatabaseID
                ].name
              ] || itemId
            );
          }
        }
        return itemId;
      }
      return 'select';
    },
    formatWithThousandSeparator(value) {
      return formatWithThousandSeparator(value);
    },
    onToggleLinkDbConfirmModal() {
      this.isShowLinkDBConfirmModal = !this.isShowLinkDBConfirmModal;
    },
    onDeleteLinkDbElement() {
      this.$emit('removeElement', this.element);
    },
  },
  watch: {
    element(updatedElement, oldElement) {
      this.setType();
      if (updatedElement && updatedElement.type === 'range') {
        this.updateRangePosition(updatedElement.id);
      }
      if (oldElement.id !== updatedElement.id) {
        this.elementName = updatedElement.name;
      }
    },
    'element.id'() {
      setTimeout(() => {
        this.triggerFileReupload();
      });
    },
  },
  computed: {
    ...mapGetters({
      getDatabaseList: 'getDatabaseList',
    }),
    addAnotherOption() {
      if (this.element.type === 'image') {
        return false;
      } else if (this.element.type === 'video') {
        return false;
      } else {
        return true;
      }
    },
    user() {
      return this.$store.state.user;
    },
    elementNeedsOptions() {
      if (typeof this.element != 'undefined')
        return (
          this.element.type === 'radio' ||
          this.element.type === 'status' ||
          this.element.type === 'checkbox' ||
          this.element.type === 'select' ||
          this.element.type === 'image' ||
          this.element.type === 'video'
        );
      else return false;
    },
    isElementNeedsRequiredToggle() {
      const elementWithoutRequired = ['checkbox', 'status'];

      return !elementWithoutRequired.includes(this.element.type);
    },
    elementNeedsSettings() {
      let withoutSettings = [
        'title',
        'description',
        'horizontalrule',
        'togglelist',
        'wrapper',
        'linktodb',
        'resultwindow',
      ];
      if (withoutSettings.includes(this.element.type)) return false;
      return true;
    },
    elementNeedsDefaultValue() {
      let withoutDefaultValue = [
        'file',
        'radio',
        'status',
        'checkbox',
        'filenew',
      ];
      if (withoutDefaultValue.includes(this.element.type)) return false;
      return true;
    },
    nameAlreadyExists() {
      return (
        this.existingElementKeys.filter((e) => e === this.element.name).length >
        1
      );
    },
    existingElementKeys() {
      return this.existingNames.concat(this.reservedElementKeys);
    },
    isCardItem() {
      return (
        this.element.attributes.hasOwnProperty('appearance') &&
        this.element.attributes.appearance === 'card'
      );
    },
    baseStructure() {
      return {
        tabs: [
          {
            id: 0,
            rows: [
              {
                id: 0,
                cols: [
                  {
                    id: 0,
                  },
                ],
              },
            ],
          },
        ],
      };
    },
    isSheetDatabaseType() {
      return this.selectedDatabase && this.selectedDatabase.name === 'sheet';
    },
    isBackgroundImage() {
      return this.element.attributes.isImgShowInBackGround;
    },
    isShowDescription() {
      return this.element.attributes.isShowTitleAndDescription;
    },
    isElementHasSettings() {
      return this.element.hasOwnProperty('settings');
    },
    isSelectedOptionLabel() {
      if (this.selectedPreviewLabel === null) {
        return 'wähle eine Option';
      }
      this.element.options.map((option) => {
        if (this.selectedPreviewLabel === option.label)
          this.element.value = option.value;
      });
      return this.selectedPreviewLabel;
    },

    typeDropdownItems() {
      const groupData = JSON.parse(JSON.stringify(this.typeGroupingList));
      const hasStatusElement = this.elements.some(
        (element) => element.type === 'status'
      );
      const isStatusSelectable =
        this.isCreateCustomDB &&
        (!hasStatusElement || this.element.type === 'status');

      for (let i = 0; i < groupData.length; i++) {
        if (!isStatusSelectable) {
          groupData[i] = groupData[i].filter((type) => type !== 'status');
        }
      }

      if (this.isImportedElement) {
        const allElemenetList = [
          'text',
          'number',
          'formatted_number',
          'email',
          'textarea',
          'status',
          'radio',
          'radiooval',
          'radiocard',
          'checkbox',
          'checkboxoval',
          'checkboxcard',
          'select',
        ];
        const selectableImportTypes = isStatusSelectable
          ? allElemenetList
          : allElemenetList.filter((type) => type !== 'status');
        groupData[0] = selectableImportTypes;
        groupData[2] = selectableImportTypes;
      }
      return groupData;
    },
    typeGermanTranslation() {
      let typeTranslationObj = {
        text: 'Text',
        number: 'Zahl',
        formatted_number: 'formatierte Zahl',
        email: 'E-Mail-Adresse',
        textarea: 'Textbereich',
        hidden: 'hidden',
        range: 'Schieberegler',
        date: 'Datum',
        'datetime-local': 'Datum & Uhrzeit',
        radio: 'Optionsfeld',
        status: 'Status',
        radiooval: 'Optionskasten',
        radiocard: 'Optionskarten',
        checkbox: 'Kontrollkästchen',
        checkboxoval: 'Kontrollkasten',
        checkboxcard: 'Kontrollkarten',
        select: 'Dropdown-Menü',
      };
      return typeTranslationObj;
    },
    optionInputType() {
      return this.element.type === 'status' ? 'radio' : this.element.type;
    },

    getSelectedDatabaseFields() {
      return this.elements
        .filter((el) => ['number', 'text', 'email', 'date'].includes(el.type))
        .map((el) => ({ name: el.name, label: el.label }));
    },

    isDatabaseLinkedViewExistInElement() {
      return this.elements.some((el) => el.type === 'databaselinkedview');
    },

    getDatabaseLinkeViewKeys() {
      return this.elements
        .filter((el) => {
          return (
            el.type === 'databaselinkedview' &&
            el?.databaseLink?.currentTableFieldKey
          );
        })
        .map((el) => el?.databaseLink?.currentTableFieldKey);
    },
    databaseLinkedViewSelectedColumn() {
      return this.selectedDatabaseColumn.length
        ? this.databaseColumns
            .filter((col) => this.selectedDatabaseColumn.includes(col.name))
            .map((item) => item.label)
            .join(', ')
        : 'Select columns';
    },
    databaseLinkedViewColumns() {
      return this.databaseColumns.filter(
        (item) => !this.selectedDatabaseColumn.includes(item.name)
      );
    },
    getPattern() {
      if (this.element.type === 'text' && this.element?.attributes?.pattern) {
        return `${this.element.attributes.pattern}`;
      }
      return null;
    },
    getCustomDatabases() {
      return this.getDatabaseList.filter(
        (database) => database.type === 'custom'
      );
    },
    getDatabaseItemsList() {
      if (
        this.element.selectedDatabaseID &&
        this.databaseItemsList &&
        this.databaseItemsList[this.element.selectedDatabaseID]
      ) {
        return this.databaseItemsList[this.element.selectedDatabaseID];
      }
      return [];
    },
    isRadioButtonNotPrefilled() {
      return this.element?.attributes?.prefilled === false;
    },
    getInputType() {
      if (
        this.taskName === 'Form' &&
        this.element.type === 'email' &&
        this.element.value[0] === '{' &&
        this.element.value[this.element.value.length - 1] === '}'
      ) {
        return 'text';
      }
      return this.element.type;
    },
    isShowTypeDropDown() {
      return (
        this.typeDropdownItems.flat().includes(this.element.type) &&
        this.groupArrayIndex !== null &&
        this.isUserHasAccess &&
        (this.isCreateCustomDB &&
        this.databaseMeta?.type === 'external database'
          ? !this.isEditMode
          : true)
      );
    },
    getSavedElementIds() {
      const databaseElements = jsonParser(this.databaseMeta?.schema);
      return databaseElements && Array.isArray(databaseElements)
        ? databaseElements.map((element) => element.id)
        : [];
    },
    isImportedElement() {
      return (
        this.importedSchemaElementIds?.length &&
        this.importedSchemaElementIds.includes(this.element.id)
      );
    },
  },

  components: {
    FormBuilder,
    Cards: cards,
    FilePicker,
    IconPicker,
    GeneralDropdown,
    NumberComponent,
    CommonModal,
    SelectDatabase,
    draggable,
  },
  directives: {
    clickOutside: {
      bind(el, binding, vnode) {
        el.eventOnClick = function (event) {
          // Check that the click was outside the el and its children
          if (!(el == event.target || el.contains(event.target))) {
            // call method provided in attribute value
            vnode.context[binding.expression]();
          }
        };

        document.addEventListener('click', el.eventOnClick);
      },
      unbind(el) {
        document.removeEventListener('click', el.eventOnClick);
      },
    },
  },
  created() {
    this.elementName = this.element.name;
    if (this.element.type === 'checkbox') {
      if (this.element.settings === undefined) {
        this.element.settings = {
          min: 0,
          max: this.element.options.length,
        };
      } else if (
        this.element.settings.min === undefined ||
        this.element.settings.max === undefined
      ) {
        this.element.settings = {
          min: 0,
          max: this.element.options.length,
        };
      }
    } else if (this.element.type === 'formatted_number') {
      if (this.element?.settings) {
        if (this.element.settings?.decSep === '-') {
          this.element.settings.decSep =
            this.element.settings?.thSep === ',' ? '.' : ',';
        }
        if (this.element.settings?.thSep === '-') {
          this.element.settings.thSep =
            this.element.settings?.decSep === '.' ? ',' : '.';
        }
      } else {
        this.element.settings = {
          decSep: ',',
          thSep: '.',
          toFixed: 2,
        };
      }
    }
    for (const element of this.elements) {
      if (
        element.type === 'databaselinkedview' &&
        !element?.settings.hasOwnProperty('connectedDatabase')
      ) {
        element.settings = {
          ...element.settings,
          connectedDatabase: {
            selectedDatabaseCaption: element.selectedDatabaseCaption,
            selectedDatabaseID: element.selectedDatabaseID,
            selectedDatabaseType: element.selectedDatabaseType,
            selectedDatabaseColumn: element?.settings?.selectedDatabaseColumn
              ? element.settings.selectedDatabaseColumn
              : [],
          },
        };
        delete element.selectedDatabaseCaption;
        delete element.selectedDatabaseID;
        delete element.selectedDatabaseType;
        if (element?.settings?.selectedDatabaseColumn) {
          delete element.settings.selectedDatabaseColumn;
        }
        if (element.linkedKey || element.linkedKeyCaption) {
          element.databaseLink = {
            currentTableFieldCaption: element.linkedKeyCaption,
            currentTableFieldKey: element.linkedKey,
          };
          delete element.linkedKeyCaption;
          delete element.linkedKey;
        }
      } else if (
        ['radio', 'status'].includes(element.type) &&
        element?.attributes?.prefilled === undefined
      ) {
        element.attributes = {
          ...element.attributes,
          prefilled: true,
        };
      } else if (
        element.type === 'html' &&
        element?.settings?.isHtmlRendered === undefined
      ) {
        element.settings = {
          ...element.settings,
          isHtmlRendered: false,
        };
      } else if (
        element.type === 'select' &&
        element.value &&
        element?.options?.length
      ) {
        const findLabel = element.options.find(
          (option) => option.value === element.value
        );
        if (findLabel?.label) {
          this.selectedPreviewLabel = findLabel.label;
        }
      } else if (
        (element.type === 'date' || element.type === 'datetime-local') &&
        element?.attributes?.todayAsDefaultValue === undefined
      ) {
        element.attributes = {
          ...element.attributes,
          todayAsDefaultValue: false,
        };
      } else if (
        element.type === 'text' &&
        element?.attributes?.errorMessage === undefined
      ) {
        element.attributes = {
          ...element.attributes,
          errorMessage: '',
        };
      }
    }
    this.setDefaultSelectableItemOptions();
    this.validateOptions();
  },
  mounted() {
    this.setType();
    let databaseCaption, databaseId;
    if (this.element.type === 'databaselinkedview') {
      databaseCaption =
        this.element?.settings?.connectedDatabase?.selectedDatabaseCaption;
      databaseId =
        this.element?.settings?.connectedDatabase?.selectedDatabaseID;
    } else {
      databaseCaption = this.element.selectedDatabaseCaption;
      databaseId = this.element.selectedDatabaseID;
    }
    if (
      databaseCaption &&
      databaseId &&
      databaseCaption !== null &&
      databaseId !== null
    ) {
      const db = this.getDatabaseList.find(
        (el) =>
          el.name.trim() === databaseId.trim() &&
          el.caption.trim() === databaseCaption.trim()
      );
      if (db) {
        if (this.element.type === 'databaselinkedview') {
          if (
            this.element?.settings?.connectedDatabase?.selectedDatabaseColumn
              ?.length
          ) {
            this.selectedDatabaseColumn =
              this.element.settings.connectedDatabase.selectedDatabaseColumn;
          }
          this.setDatabaseLinkedViewSchema(db);
        }
        if (Object.keys(db).length) {
          this.selectDatabaseLink(db, false);
        }
      }
    }

    if (this.element.type === 'range') {
      this.setRangePosition(this.element.id);
    }

    this.triggerFileReupload();
  },
};
</script>

<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';

.element-props {
  width: fit-content;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.element-props-modal {
  text-align: left;
  border-left: 1px solid #dee3e9;
  border-left-width: 1px;
  border-left-style: solid;
  border-left-color: rgb(222, 227, 233);
  border-radius: 0px 19px 19px 0px;
  background: #ffffff;
  display: block;
  text-align: left;
  font-size: 12px;
  line-height: 17px;
  color: #5f697a;
  height: 100%;
  position: relative;
  width: 425px;
}

.element-props .element-props-modal.overflow-hidden {
  overflow: hidden !important;
}

.element-props-modal.shift-right {
  right: 15%;
  top: 1%;
  height: 98%;
}

.content {
  background-color: #fff;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
}

.heading {
  padding: 15px 15px 0px;
  text-align: center;
}

.pull-right {
  float: right;
  margin-right: 15px;
  margin-top: 15px;
}

.tab {
  text-align: left;
  border-top: 1px solid #eaecf1;
  background: #fff;
  padding: 38px 40px 2px 40px;
  min-height: 190px;
}
.tab .icon-picker-url-selector {
  position: relative;
}

.already-exists {
  background: #ff050578;
}

.element-props .input-error {
  background: #ff050578;
}

.error {
  animation: shake 0.2s ease-in-out 0s 2;
  box-shadow: 0 0 0.5em red;
}

.options {
  width: 100%;
  margin: 0;
  height: 36px;
  display: inline;
}

.options .img-preview {
  width: 55px;
}
.options img {
  width: 50px;
}

.options table {
  width: 90%;
}

.options input {
  border: 0;
  background: transparent;
}

.options i {
  float: right;
  margin-top: -30px;
}

.options.large i {
  margin-top: -55px;
}
.options.large.option-card i {
  margin-top: -80px;
}

input[type='file'] {
  padding: 6px;
}

.options input[type='text'] {
  width: 68%;
  margin-left: 1px;
  display: inline;
  margin-top: 0px;
  margin-bottom: 0px;
  padding-top: 0px;
  height: 43px;
  font-size: 15px;
}

.options input[type='radio'],
.options input[type='checkbox'] {
  width: 21px;
  float: left;
  margin-bottom: 9px;
  height: 19px;
  margin-top: 13px;
}

.type-select-wrapper {
  display: flex;
  justify-content: space-around;
  font-size: 15px;
  color: #464d5d;
  font-weight: 400;
  line-height: 35px;
  margin-bottom: 5px;
}
.type-select-wrapper span {
  cursor: pointer;
}
.type-select-wrapper span.active {
  text-decoration: underline;
}

.icon-wrapper {
  display: flex;
  flex-wrap: wrap;
  height: 160px;
  overflow: auto;
}
.icon-wrapper img {
  cursor: pointer;
  width: 26px;
  padding: 6px;
  margin: 5px;
  background: #cfd0d3;
}

.image-preview {
  width: 50px;
}

h1 {
  padding-top: 50px;
  padding-bottom: 8px;
  text-align: center;
  font-size: 33px;
  color: #464d5d;
  margin: 0 0 12px;
  font-weight: 400;
  line-height: 35px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
}

h3 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 10px;
}

h4 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 0px;
}

select {
  width: 70%;
}

.date {
  width: 53%;
}

.time {
  width: 33%;
}

textarea {
  resize: none;
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 0;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 200px;
  width: 100%;
  overflow: scroll;
}

button {
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  margin-top: 25px;
  margin-bottom: 20px;
  margin-right: 30px;
  width: fit-content;
}

button.default {
  color: #464d5d;
  background: #fff;
}

.input-group {
  display: inline-block;
  width: 100%;
}

.imput-group > input {
  width: 40%;
  margin: 0px 20px 20px 0px;
}

.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
}

.btn {
  text-decoration: none;
  color: #fff;
  border: 3px solid #000;
  border-radius: 0.375em;
  cursor: unset;
  display: inline-block;
  font-family: proxima-nova, Helvetica Neue, Arial, sans-serif;
  font-weight: 700;
  line-height: 23px;
  padding: 0.5rem 1.5rem;
  white-space: pre;
  font-size: 0.9375rem;
  opacity: 1;
  transition: transform 0.2s linear 0s, background-color 0.2s linear 0s;
  transform: translateY(0) scale(1.001);
  background-color: #000;
  margin-bottom: 10px;
}
ul.tabsLabels {
  display: inline-block;
  padding: 0;
  margin: 0 0 -1px;
}

.element-props-modal ul.tabsLabels li {
  display: inline-block;
  margin-right: 44px;
  list-style: none;
  padding: 0;
  line-height: 14px;
}

.element-props-modal:not(.custom) li {
  font-size: 14px;
  line-height: 25px;
  color: #7e8890;
}

.element-props-modal ul.tabsLabels a {
  color: #a4abb1;
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
  padding: 21px 7px 22px 33px;
  border-bottom: 2px solid transparent;
  display: block;
  position: relative;
}

.element-props-modal ul.tabsLabels a.datetime {
  padding: 21px 7px 22px 0px;
}

a {
  text-decoration: none;
  -webkit-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  -o-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  cursor: pointer;
}

a {
  background-color: transparent;
}

.element-props-modal ul.tabsLabels a.active {
  border-color: #52b266;
}

.element-props-modal ul.tabsLabels a.active,
.element-props-modal ul.tabsLabels a:hover {
  color: #464d5d;
  text-decoration: none;
}

/*@media not all, not all, (-webkit-min-device-pixel-ratio: 1.5), not all, (min-resolution: 1.5dppx)*/
.tabsLabels .email {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -1100px -1110px;
}

.tabsLabels .alert {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -546px -1110px;
}

p {
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  color: #7e8890;
  margin: 25px 0px 25px 0px;
}

.systems {
  background-color: #f9f9fb;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  color: #5f697a;
  line-height: 17px;
  margin: 0;
  display: block;
  overflow: auto;
  width: 100%;
}

.item-wrapper {
  display: block;
  position: relative;
  float: left;
  width: 120px;
  border-radius: 4px;
  background: #fff;
  height: 150px;
  text-align: center;
  margin: 0 39px 43px 0;
  -webkit-box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.item-wrapper h2 {
  color: #424956;
  font-size: 12px;
  font-weight: 400;
  line-height: inherit;
  margin-top: 0px;
}

.systems-wrapper {
  width: 100%;
  margin: 24px 31px;
}

.img-wrapper {
  width: 100%;
  height: 111px;
}

.systems .logo {
  position: absolute;
  width: 70%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.input-group > button {
  min-width: 0;
  width: 99px;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  background: #fff;
  margin-bottom: 0;
  margin-left: 0;
  border-radius: 0 3px 3px 0;
  margin-top: 0;
  font-size: 35px;
  font-weight: 200;
}

.input-group > select {
  margin-right: 0;
  border-radius: 0 3px 3px 0;
}

form {
  background: #f9f9fb;
  width: 100%;
  padding: 30px;
  text-align: left;
}

label,
.element-props .link-db-container ::v-deep h3,
.element-props .database-linked-view ::v-deep h3 {
  font-family: 'Open Sans', open-sans, sans-serif;
  display: block;
  padding-top: 0;
  padding-bottom: 9px;
  margin-right: 10px;
  margin-bottom: 0px;
  color: #464d5d;
  font-size: 13px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-weight: 300;
  width: 50%;
}

input,
select {
  border-radius: 0;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  width: 100%;
  margin-bottom: 0;
  height: 37px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0px 15px 0px 15px;
}
input[type='range'] {
  padding: 0;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: '';
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #000;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/*Switch*/
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: '';
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #000;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.option-list {
  clear: both;
  float: left;
  position: relative;
  width: 100%;
}

.option-list > ul {
  padding: 0;
  margin: 0;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  list-style: none;
}

.option-list ul li {
  float: left;
  clear: both;
  width: 100%;
  border-bottom: 1px solid #d8dee6;
  padding: 15px 0;
  font-size: 14px;
  color: #7e8890;
  line-height: 35px;
}

.option-list ul li.active {
  color: #323a45;
}

.switch-group {
  height: 65px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.switch-group > label.caption {
  height: 53px;
  padding-top: 19px;
}

.new-item {
  border: 0;
  background: transparent;
  font-size: 15px;
}

.new-item::placeholder {
  text-decoration: underline;
}

.new-item:focus::placeholder {
  color: transparent;
}

.new-item:focus {
  background: #fff;
}

#add-element {
  background: #fff;
  padding: 0;
}

.decimal-description {
  margin: 0 0 5px 0;
}

@keyframes shake {
  0% {
    margin-left: 0rem;
  }
  25% {
    margin-left: 0.5rem;
  }
  75% {
    margin-left: -0.5rem;
  }
  100% {
    margin-left: 0rem;
  }
}

input.invalid {
  background-color: #ff050578;
  color: red;
  border: 1px solid;
}

p.invalid {
  color: red;
}

.list-wrapper {
  margin-bottom: 25px;
}

.list-wrapper .schema-item {
  border: solid 1px #9e9e9e;
  width: 94%;
  color: #444444;
  padding: 10px;
}

.list-wrapper input.new-item {
  padding: 0;
  margin: 0;
}

.list-wrapper .item-list {
  margin-top: 15px;
}

.list-wrapper .add-button-wrapper {
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
}

.list-wrapper .add-button-wrapper .add-button {
  cursor: pointer;
  display: block;
  color: white;
  border-radius: 50%;
  background-color: #191f25;
  height: 35px;
  width: 35px;
  line-height: 37px;
  font-size: 25px;
  font-weight: 100;
  -webkit-box-shadow: 0.5px 0.87px 5px 0 rgb(0 0 0 / 28%);
  box-shadow: 0.5px 0.87px 5px 0 rgb(0 0 0 / 28%);
  -webkit-transition: -webkit-transform 0.2s ease-in-out;
  transition: -webkit-transform 0.2s ease-in-out;
  transition: transform 0.2s ease-in-out;
  transition: transform 0.2s ease-in-out, -webkit-transform 0.2s ease-in-out;
  background-size: 100%;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  margin-top: 15px;
}

.list-wrapper .add-button-wrapper .add-button:hover {
  transform: scale(1.1);
}

.list-wrapper .item-list .list-item {
  border-bottom: solid 1px;
  padding: 5px 0 5px 0;
}

.list-wrapper .item-list .list-item input {
  margin: 0;
}

/* el-props-form-builder */

::v-deep .el-props-form-builder #codelosForm {
  width: 100%;
}

::v-deep .el-props-form-builder .form-header {
  display: none;
}

::v-deep .el-props-form-builder .add-button {
  height: 25px;
  width: 25px;
  line-height: 27px;
  font-size: 25px;
}

::v-deep .el-props-form-builder .drop-down {
  top: 0;
  margin-left: 0;
  margin-top: 15px;
  height: fit-content;
}

[disabled] {
  opacity: 0.5;
  cursor: not-allowed !important;
}
.edit-item ::v-deep .file-selected {
  margin-left: 0 !important;
  width: 100%;
}

.element-props-modal
  .link-db-container
  .database-dropdown
  ::v-deep
  .customDropdown {
  width: 100% !important;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  height: 37px;
  color: #464d5d;
  justify-content: space-between;
  padding: 0px 15px 0px 15px;
}

.element-props-modal
  .link-db-container
  .database-dropdown
  ::v-deep
  .database-dropdown-value-container {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-all;
  text-align: left;
}

.element-props-modal .link-db-container ::v-deep .database-dropdown {
  width: 100%;
}
.element-props-modal
  .link-db-container
  ::v-deep
  .database-dropdown
  .dropdown-menu {
  width: 100%;
}

.element-props-modal
  .link-db-container
  ::v-deep
  .database-dropdown
  .dropdown-menu
  .dropdown-item {
  width: 94%;
}

.element-props-modal .content .tab .loading-overlay {
  position: absolute;
  background: transparent;
  width: 100%;
  z-index: 1;
  top: 0;
  left: 0;
  text-align: center;
  height: 100%;
  border-radius: 4px;
}
.element-props-modal .content .tab .loading-overlay .progress-icon {
  content: ' ';
  display: block;
  width: 25px;
  height: 25px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #1f2532c7;
  border-color: #1f2532c7 transparent #1f2532c7 transparent;
  animation: progress-icon 1.2s linear infinite;
  margin: 0 auto;
  top: 5px;
  position: absolute;
  left: 44%;
}

@keyframes progress-icon {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.options .title-input {
  border: 2px solid #000;
  border-radius: 4px;
  margin-left: 0px !important;
}

.options .description-input {
  margin-top: 5px;
  border: 1px solid #747070;
  height: 100px;
}
::v-deep .number-component .number-input {
  border: 1px solid #dee3e9 !important;
  border-radius: 2px;
  border-radius: 0;
  background: #fff;
  height: 37px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  box-shadow: none;
  box-sizing: border-box;
  padding: 0px 15px 0px 15px;
}
.tab .icon-picker-url-selector .btn {
  margin-bottom: 0;
  margin-top: 5px;
}

::v-deep .dropdown-component {
  width: 100%;
}
::v-deep .dropdown-component .customDropdown {
  width: 100%;
  justify-content: space-between;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  color: #464d5d;
}
::v-deep .show {
  width: 100%;
}
.element-props-modal .content ::v-deep .cards-grid .form-item-wrap {
  flex-direction: column;
  align-items: flex-start !important;
  box-sizing: border-box;
}

.element-props-modal .content ::v-deep .cards-grid .form-item-wrap input {
  box-sizing: border-box;
  margin-top: 4px;
}

.element-props-modal
  .content
  ::v-deep
  .cards-grid
  .item.active
  .row
  .number-component
  input {
  margin-bottom: 0;
  background: rgb(247, 247, 247);
  height: 30px;
  padding: 0 15px 0 5px;
  width: 100%;
  margin-left: 3px;
  padding-left: 5px;
  border-radius: 5px;
  border: solid 1px !important;
}
.element-props-modal
  .content
  .schema-item
  ::v-deep
  .row
  .number-component
  input {
  border-radius: 2px;
  border: 1px solid #dee3e9 !important;
  padding: 8px 12px;
  background: #fff;
  height: auto;
}

::v-deep .element-props-modal .selected a {
  background: #f0f0f0 !important;
}
::v-deep .element-props-modal .group-items a {
  width: 100% !important;
}
::v-deep .b-toast-danger .toast {
  color: red !important;
}
.element-props-modal .numeric-input-wrapper .range-input {
  border: none !important;
  margin: 0 !important;
}

.element-props-modal .numeric-input-wrapper {
  position: relative;
}

.element-props-modal .numeric-input-wrapper.range-wrapper {
  height: 66px;
  display: flex;
  flex-direction: column;
  justify-content: start;
}

.element-props-modal .numeric-input-wrapper .range-output-value {
  position: absolute;
  left: 0;
  top: 54px;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  color: #5f5f5f;
  min-width: 36px;
  height: 18px;
  border-radius: 6px;
  border: 0.5px solid #bdbdbd;
  text-align: center;
  color: #000;
}

.element-props-modal .numeric-input-wrapper .range-slider-values {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  line-height: 16.55px;
  color: #5f5f5f;
}

.element-props ::v-deep .confirm-message {
  color: #212529;
  font-size: 16px;
  margin: 0;
  text-align: center;
}
.element-props .linkdb-confirm-modal ::v-deep .modal-inner {
  max-width: 465px;
}
.element-props
  .linkdb-confirm-modal
  ::v-deep
  .modal-inner
  .confirm-message-wrapper {
  max-width: 100%;
}
.element-props .confirm-message-wrapper {
  max-width: 300px;
  margin-bottom: 24px;
}
.element-props .checkbox-error {
  background: #ff050578;
}
.element-props-modal .link-db-container ::v-deep .select-operation,
.element-props-modal .database-linked-view ::v-deep .select-operation {
  width: 100% !important;
  height: 37px;
  color: #464d5d;
  justify-content: space-between;
  border: none !important;
  margin-bottom: 1rem;
}
.element-props-modal .link-db-container ::v-deep .select-database-input,
.element-props-modal .database-linked-view ::v-deep .select-database-input,
.element-props-modal
  .link-db-container
  ::v-deep
  .select-database-input::placeholder,
.element-props-modal
  .database-linked-view
  ::v-deep
  .select-database-input::placeholder {
  color: #464d5d;
  font-size: 14px;
  font-weight: 400;
}
.element-props-modal
  .link-db-container
  ::v-deep
  .select-database
  .dropdown.show:before {
  top: 38px !important;
}
.element-props .database-linked-view .selected-columns {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 5px;
  color: #464d5d;
}
.element-props .database-linked-view .selected-columns .drag-wrapper {
  display: flex;
  gap: 0;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  border-bottom: 1px solid #d1d1d1;
  max-height: 250px;
  overflow: auto;
  padding-right: 4px;
}

.element-props
  .database-linked-view
  .selected-columns
  .drag-wrapper
  .selected-column {
  padding: 12px 0;
  display: flex;
  width: 100%;
  max-width: 100%;
  cursor: default;
  align-items: center;
  font-size: 15px;
  justify-content: space-between;
  border-top: 1px solid #d1d1d1;
}

.element-props
  .database-linked-view
  .selected-columns
  .drag-wrapper
  .selected-column
  .drag-content {
  display: flex;
  gap: 10px;
  align-items: center;
  cursor: pointer;
}
.element-props .database-linked-view .selected-columns .close {
  cursor: pointer;
}

.element-props .database-linked-view ::v-deep .display-columns {
  overflow-x: hidden;
  max-width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.element-props .database-linked-view .column-loader {
  position: relative;
  height: 75px;
}
.element-props .database-linked-view .column-loader .progress-icon {
  width: 50px !important;
  height: 50px !important;
  left: 42% !important;
}
.element-props
  .database-linked-view
  ::v-deep
  .is-dropdown-container-overflowed {
  padding-left: 7px !important;
}

.element-props .selectable-elements-option-wrapper {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  gap: 10px;
}
.element-props .disable-element {
  pointer-events: none;
}
.element-props .showcasefield-wrapper {
  max-width: 536px;
  margin-bottom: 24px;
}
.list-wrapper
  .schema-item
  ::v-deep
  .el-props-form-builder
  .tab-form
  .form-container
  .field-search-wrapper {
  width: 100%;
  margin: 10px 0;
}

.list-wrapper
  .schema-item
  ::v-deep
  .el-props-form-builder
  .tab-form
  .form-container
  #codelosForm
  .form-elements
  .form-builder-element-wrap {
  margin: 0;
  max-width: 75%;
}

.list-wrapper
  .schema-item
  ::v-deep
  .el-props-form-builder
  .tab-form
  .form-container
  #codelosForm
  .edit-mode-tools
  .dropdown-menu {
  min-width: 130px;
}

.list-wrapper
  .schema-item
  ::v-deep
  .el-props-form-builder
  .tab-form
  .form-container
  #codelosForm
  .edit-mode-tools
  .customDropdown {
  border: none;
}
</style>
